/**
 * Amolee Product Info – main section JS
 * Reads Liquid data from #amolee-product-data JSON island.
 */
document.addEventListener('DOMContentLoaded', function () {
  /* ------------------------------------------------------------------ */
  /*  Bootstrap: read JSON island & cache section element                */
  /* ------------------------------------------------------------------ */
  var dataEl = document.getElementById('amolee-product-data');
  if (!dataEl) return;

  var cfg;
  try { cfg = JSON.parse(dataEl.textContent); } catch (e) { return; }

  var section = document.querySelector('[data-section-id="' + cfg.sectionId + '"]');
  if (!section) return;

  var variantsData = cfg.variants;
  var productMedia = cfg.media;
  var moneyFormat = cfg.moneyFormat;
  var originalSrc = cfg.featuredMediaSrc;
  var viewModelSrc = cfg.viewModelSrc || '';
  var viewDimensionSrc = cfg.viewDimensionSrc || '';
  var viewPackagingSrc = cfg.viewPackagingSrc || '';
  var viewCertificateSrc = cfg.viewCertificateSrc || '';
  var currentSideViewSrc = cfg.initialSideViewSrc || '';
  var currentTopViewSrc = cfg.initialTopViewSrc || '';
  var productId = cfg.productId || '';
  var productHandle = cfg.productHandle || '';
  var basePrice = cfg.initialVariantPrice;
  var variantMeta = cfg.variantMeta || {};
  var productTitle = cfg.productTitle || '';
  var productDescription = cfg.productDescription || '';
  var accentStoneDefaultName = (cfg.accentStoneDefaultName || 'Lab Grown').toString().trim().toLowerCase();
  var accentStonePricing = Array.isArray(cfg.accentStonePricing) ? cfg.accentStonePricing : [];
  var accentStonePrice = 0;

  var specialViewMap = {
    side_view: {
      src: currentSideViewSrc,
      defaultLabel: 'Side View'
    },
    top_view: {
      src: currentTopViewSrc,
      defaultLabel: 'Top View'
    },
    model: {
      src: viewModelSrc,
      defaultLabel: 'View on Model'
    },
    dimension: {
      src: viewDimensionSrc,
      defaultLabel: 'View Dimension'
    },
    packaging: {
      src: viewPackagingSrc,
      defaultLabel: 'View Packaging'
    },
    certificate: {
      src: viewCertificateSrc,
      defaultLabel: 'View Certificate'
    }
  };

  /* ------------------------------------------------------------------ */
  /*  Currency and money formatting utilities                            */
  /* ------------------------------------------------------------------ */
  var activeCurrency = cfg.currency;
  if (!activeCurrency) {
    if (cfg.countryCode === 'IN') activeCurrency = 'INR';
    else if (cfg.countryCode === 'GB' || cfg.countryCode === 'UK') activeCurrency = 'GBP';
    else if (cfg.countryCode === 'CA') activeCurrency = 'CAD';
    else if (cfg.countryCode === 'US' || cfg.countryCode === 'ROW') activeCurrency = 'USD';
    else activeCurrency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
  }
  var CURRENCY_LOCALE = { INR: 'en-IN', USD: 'en-US', GBP: 'en-GB', CAD: 'en-CA', EUR: 'en-IE', AUD: 'en-AU' };

  function formatDisplayMoney(minor, currency) {
    var curr = currency || activeCurrency;
    var isIndia = (curr === 'INR' || (cfg.countryCode || '').toUpperCase() === 'IN');
    try {
      var amount = (Number(minor) || 0) / 100;
      if (isIndia) {
        amount = Math.round(amount);
      }
      return new Intl.NumberFormat(CURRENCY_LOCALE[curr] || 'en-GB', {
        style: 'currency',
        currency: curr,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(amount);
    } catch (e) {
      var fallbackAmount = (Number(minor || 0) / 100);
      if (isIndia) {
        fallbackAmount = Math.round(fallbackAmount);
      }
      return fallbackAmount.toFixed(2);
    }
  }

  function formatMoney(cents) {
    return formatDisplayMoney(cents, activeCurrency);
  }

  /**
   * Resolve the display price for a variant.
   * Returns { minor, currency, compareMinor } where amounts are in minor units.
   */
  function getVariantDisplay(variant) {
    var nativeMinor = variant ? (Number(variant.price) || 0) : 0;
    var nativeCompare = variant ? (Number(variant.compare_at_price) || 0) : 0;
    var compareMinor = nativeCompare > nativeMinor ? nativeCompare : 0;
    return {
      minor: nativeMinor,
      currency: activeCurrency,
      compareMinor: compareMinor
    };
  }

  /**
   * Add-on pricing display (certificates, chain, push) using native Shopify pricing.
   */
  function getAddonRegionDisplay(source, nativeMinor) {
    var minor = 0;
    if (nativeMinor !== undefined && nativeMinor !== null && !isNaN(Number(nativeMinor))) {
      minor = Math.round(Number(nativeMinor));
    } else if (source && source.price !== undefined && source.price !== null && !isNaN(Number(source.price))) {
      minor = Math.round(Number(source.price));
    } else if (source && source.dataset && source.dataset.price != null && !isNaN(parseFloat(source.dataset.price))) {
      minor = Math.round(parseFloat(source.dataset.price) * 100);
    }
    return {
      minor: minor,
      currency: activeCurrency
    };
  }

  /**
   * Convenience wrapper for DOM elements (cert radios): resolves the price
   * and returns the minor-unit amount.
   */
  function getAddonRegionPriceCents(el) {
    if (!el) return 0;
    if (el.dataset && el.dataset.price != null && el.dataset.price !== '') {
      var val = parseFloat(el.dataset.price);
      return isNaN(val) ? 0 : Math.round(val * 100);
    }
    return 0;
  }

  // --- Update meta tags and document title on variant change ---
  function updateMetaTags(variant) {
    var meta = (variant && variantMeta[variant.id]) || {};
    var title = (meta.title && meta.title.trim()) ? meta.title : productTitle;
    var rawDescription = (meta.description && meta.description.trim()) ? meta.description : productDescription;
    var tempDiv = document.createElement('div');
    tempDiv.innerHTML = rawDescription;
    var description = (tempDiv.textContent || tempDiv.innerText || '').trim();
    var safeAccentPrice = Number(accentStonePrice) || 0;
    var totalAmountMinor = (variant && variant.price != null) ? (Number(variant.price) + safeAccentPrice) : 0;
    if (activeCurrency === 'INR' || (cfg.countryCode || '').toUpperCase() === 'IN') {
      totalAmountMinor = Math.round(totalAmountMinor / 100) * 100;
    }
    var amount = totalAmountMinor ? (totalAmountMinor / 100).toFixed(2) : '';
    var currency = activeCurrency;

    // Update document title
    document.title = title;

    // Update meta description
    var metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) metaDesc.setAttribute('content', description);

    // Update og:title, og:description, og:url, og:type
    var ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) ogTitle.setAttribute('content', title);
    var ogDesc = document.querySelector('meta[property="og:description"]');
    if (ogDesc) ogDesc.setAttribute('content', description);
    var ogUrl = document.querySelector('meta[property="og:url"]');
    if (ogUrl) ogUrl.setAttribute('content', window.location.href);
    var ogType = document.querySelector('meta[property="og:type"]');
    if (ogType) ogType.setAttribute('content', 'product');

    // Update og:price:amount, og:price:currency
    var ogAmount = document.querySelector('meta[property="og:price:amount"]');
    if (ogAmount) ogAmount.setAttribute('content', amount);
    var ogCurrency = document.querySelector('meta[property="og:price:currency"]');
    if (ogCurrency) ogCurrency.setAttribute('content', currency);

    // Update Twitter card title & description only (image handled by updateVariantImage)
    var twTitle = document.querySelector('meta[name="twitter:title"]');
    if (twTitle) twTitle.setAttribute('content', title);
    var twDesc = document.querySelector('meta[name="twitter:description"]');
    if (twDesc) twDesc.setAttribute('content', description);
  }

  function parseMoneyAmountToCents(value) {
    if (value === null || value === undefined || value === '') return 0;
    var numericValue = String(value).replace(/[^0-9.\-]/g, '');
    if (!numericValue) return 0;
    return Math.round(parseFloat(numericValue) * 100);
  }

  /* ================================================================== */
  /*  VARIANT LOGIC                                                      */
  /* ================================================================== */
  var form = section.querySelector('#amolee-product-form');

  function getSelectedOptions() {
    var selected = [];
    if (!form) return selected;
    var pairs = [];
    form.querySelectorAll('input[type="radio"]:checked').forEach(function (radio) {
      var pos = radio.dataset.optionPosition;
      // Only include true product-option radios (numeric position 1, 2, 3…)
      if (pos && /^\d+$/.test(String(pos))) {
        pairs.push({ pos: parseInt(pos, 10), value: radio.value });
      }
    });
    // Sort ascending by position so the array aligns with variant.options[]
    pairs.sort(function (a, b) { return a.pos - b.pos; });
    pairs.forEach(function (p) { selected.push(p.value); });
    return selected;
  }

  function findMatchingVariant(selectedOptions) {
    return variantsData.find(function (variant) {
      return variant.options.every(function (option, index) {
        return option === selectedOptions[index];
      });
    });
  }

  function getCurrentVariant() {
    var input = section.querySelector('input[name="id"]');
    if (!input) return null;
    var id = parseInt(input.value, 10);
    return variantsData.find(function (v) { return v.id === id; });
  }

  function getVariantByMediaId(mediaId) {
    if (mediaId == null) return null;
    var mediaKey = String(mediaId);
    return variantsData.find(function (variant) {
      return variant && variant.featured_media && String(variant.featured_media.id) === mediaKey;
    }) || null;
  }

  function syncWishlistButton(variant) {
    var wishlistBtn = section.querySelector('[data-wishlist-button]');
    if (!wishlistBtn) return;

    var activeVariant = variant || getCurrentVariant();
    var meta = (activeVariant && variantMeta[activeVariant.id]) || {};
    var displayTitle = (meta.title && meta.title.trim())
      ? meta.title
      : (activeVariant ? activeVariant.title : productTitle);
    var variantImage = '';

    if (activeVariant && activeVariant.featured_media && activeVariant.featured_media.preview_image) {
      variantImage = activeVariant.featured_media.preview_image.src || '';
    }

    if (!variantImage && originalSrc) {
      variantImage = originalSrc;
    }

    wishlistBtn.setAttribute('data-product-id', String(productId || wishlistBtn.getAttribute('data-product-id') || ''));
    wishlistBtn.setAttribute('data-product-handle', productHandle || wishlistBtn.getAttribute('data-product-handle') || '');
    wishlistBtn.setAttribute('data-product-title', productTitle || wishlistBtn.getAttribute('data-product-title') || '');

    if (activeVariant) {
      var safeAccentPrice = Number(accentStonePrice) || 0;
      var activePrice = activeVariant.price != null ? (Number(activeVariant.price) + safeAccentPrice) : '';
      var activeComparePrice = activeVariant.compare_at_price != null && activeVariant.compare_at_price > 0
        ? (Number(activeVariant.compare_at_price) + safeAccentPrice)
        : 0;
      if (activeCurrency === 'INR' || (cfg.countryCode || '').toUpperCase() === 'IN') {
        if (activePrice !== '') activePrice = Math.round(Number(activePrice) / 100) * 100;
        if (activeComparePrice) activeComparePrice = Math.round(Number(activeComparePrice) / 100) * 100;
      }
      wishlistBtn.setAttribute('data-variant-id', String(activeVariant.id));
      wishlistBtn.setAttribute('data-variant-title', activeVariant.title || '');
      wishlistBtn.setAttribute('data-variant-image', variantImage);
      wishlistBtn.setAttribute('data-variant-price', String(activePrice));
      wishlistBtn.setAttribute('data-variant-compare-at-price', String(activeComparePrice));
      wishlistBtn.setAttribute('data-variant-options', JSON.stringify(activeVariant.options || []));
      wishlistBtn.setAttribute('data-display-title', displayTitle || activeVariant.title || productTitle || '');
    }

    if (window.AmolihWishlist && typeof window.AmolihWishlist.syncButton === 'function') {
      window.AmolihWishlist.syncButton(wishlistBtn);
    }
  }

  function syncOptionSelectorsToVariant(variant) {
    if (!form || !variant) return;

    var optionValues = variant.options || [];

    form.querySelectorAll('input[type="radio"]').forEach(function (radio) {
      var pos = parseInt(radio.dataset.optionPosition, 10);
      if (isNaN(pos) || !optionValues[pos - 1]) return;
      radio.checked = radio.value === optionValues[pos - 1];
    });

    section.querySelectorAll('.amolee-product-info__option-group').forEach(function (group) {
      group.querySelectorAll('[class*="-selector__option"]').forEach(function (opt) {
        opt.classList.remove('is-selected');
      });

      var checked = group.querySelector('input[type="radio"]:checked');
      if (!checked) return;

      var label = checked.closest('[class*="-selector__option"]');
      if (label) {
        label.classList.add('is-selected');
        var track = group.querySelector('[class*="-selector__track"]');
        if (track && label.offsetLeft !== undefined) {
          requestAnimationFrame(function () {
            var optionCenter = label.offsetLeft + (label.clientWidth / 2);
            var trackCenter = track.clientWidth / 2;
            var scrollLeft = optionCenter - trackCenter;
            track.scrollTo({ left: Math.max(0, scrollLeft), behavior: 'smooth' });
          });
        }
      }

      var display = group.querySelector('[id*="selected-"][id*="-display-"]');
      if (display) {
        display.textContent = label && label.dataset.value ? label.dataset.value : checked.value;
      }
    });
  }

  function syncVariantFromMediaId(mediaId) {
    var variant = getVariantByMediaId(mediaId);
    if (!variant) return;

    syncOptionSelectorsToVariant(variant);
    updatePrices(variant);
    updateURL(variant);
  }

  /* ------------------------------------------------------------------ */
  /*  Update prices (main block, sticky bar, add-to-cart state)          */
  /*  AMOLIH CUSTOM PRICE DISPLAY START                                  */
  /*  Render the localized price, compare-at and discount for a variant. */
  /*  Used by updatePrices() on variant change and once on initial load. */
  /* ------------------------------------------------------------------ */
  /* ------------------------------------------------------------------ */
  /*  Dynamic Additional Savings & Discounted Price (Offer's info)        */
  /*  Calculates savings & get-it-for price based on the effective price   */
  /*  including accent stone options for all regions and currencies.      */
  /* ------------------------------------------------------------------ */
  function updateOfferSavingsDisplay(productPrice, currency) {
    var savingsContainer = section.querySelector('.amolee-save-amount-text');
    if (!savingsContainer) return;

    var percentAttr = savingsContainer.getAttribute('data-coupon-percent');
    var percent = parseInt(percentAttr, 10);
    if (isNaN(percent) || percent <= 0) {
      percent = 5;
    }

    var curr = currency || activeCurrency;
    var isIndia = (curr === 'INR' || (cfg.countryCode || '').toUpperCase() === 'IN');
    var priceMinor = Number(productPrice) || 0;
    var formattedSavings;
    var formattedDiscounted;

    if (isIndia) {
      var baseRupees = Math.round(priceMinor / 100);
      var savingsRupees = Math.round(baseRupees * (percent / 100));
      var discountedRupees = baseRupees - savingsRupees;

      try {
        formattedSavings = new Intl.NumberFormat('en-IN', {
          style: 'currency',
          currency: 'INR',
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }).format(savingsRupees);
        formattedDiscounted = new Intl.NumberFormat('en-IN', {
          style: 'currency',
          currency: 'INR',
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }).format(discountedRupees);
      } catch (e) {
        formattedSavings = '₹' + savingsRupees.toFixed(2);
        formattedDiscounted = '₹' + discountedRupees.toFixed(2);
      }
    } else {
      var savingsMinor = Math.round(priceMinor * (percent / 100));
      var discountedMinor = priceMinor - savingsMinor;

      formattedSavings = formatDisplayMoney(savingsMinor, curr);
      formattedDiscounted = formatDisplayMoney(discountedMinor, curr);
    }

    var valEl = savingsContainer.querySelector('.amolee-savings-value');
    if (valEl) {
      valEl.textContent = formattedSavings;
    }

    var discountedEl = section.querySelector('.amolee-discounted-price-value');
    if (discountedEl) {
      discountedEl.textContent = formattedDiscounted;
    }
  }

  function refreshPriceDisplay(variant) {
    if (!variant) return;

    var display = getVariantDisplay(variant);
    var currency = display.currency;
    var isIndia = (currency === 'INR' || (cfg.countryCode || '').toUpperCase() === 'IN');
    var safeAccentStonePrice = Number(accentStonePrice) || 0;
    if (isIndia) {
      safeAccentStonePrice = Math.round(safeAccentStonePrice / 100) * 100;
    }
    var effectivePrice = (display.minor || 0) + safeAccentStonePrice;
    var effectiveCompare = display.compareMinor ? (display.compareMinor + safeAccentStonePrice) : 0;
    if (isIndia) {
      effectivePrice = Math.round(effectivePrice / 100) * 100;
      if (effectiveCompare) {
        effectiveCompare = Math.round(effectiveCompare / 100) * 100;
      }
    }

    var priceElement = section.querySelector('.amolee-product-info__price');
    var comparePriceElement = section.querySelector('.amolee-product-info__compare-price');
    var discountBadge = section.querySelector('.amolee-product-info__discount-badge');
    var priceBlock = section.querySelector('.amolee-product-info__price-block');

    if (priceElement) priceElement.textContent = formatDisplayMoney(effectivePrice, currency);

    if (effectiveCompare && effectiveCompare > effectivePrice) {
      if (!comparePriceElement) {
        var cSpan = document.createElement('span');
        cSpan.className = 'amolee-product-info__compare-price';
        cSpan.textContent = formatDisplayMoney(effectiveCompare, currency);
        if (priceBlock) priceBlock.appendChild(cSpan);
      } else {
        comparePriceElement.textContent = formatDisplayMoney(effectiveCompare, currency);
      }

      var pct = Math.round(((effectiveCompare - effectivePrice) * 100.0) / effectiveCompare);
      if (!discountBadge) {
        var bSpan = document.createElement('span');
        bSpan.className = 'amolee-product-info__discount-badge';
        bSpan.textContent = pct + '% OFF';
        if (priceBlock) priceBlock.appendChild(bSpan);
      } else {
        discountBadge.textContent = pct + '% OFF';
      }
    } else {
      if (comparePriceElement) comparePriceElement.remove();
      if (discountBadge) discountBadge.remove();
    }

    // Sticky price
    var stickyPrice = section.querySelector('#sticky-price') || section.querySelector('#addon-total-price');
    var stickyOriginal = section.querySelector('.amolee-product-info__original-price');
    var priceAction = section.querySelector('.amolee-product-info__sticky-price');

    if (stickyPrice) stickyPrice.textContent = formatDisplayMoney(effectivePrice, currency);

    if (effectiveCompare && effectiveCompare > effectivePrice) {
      if (!stickyOriginal && priceAction) {
        var oSpan = document.createElement('span');
        oSpan.className = 'amolee-product-info__original-price';
        oSpan.textContent = formatDisplayMoney(effectiveCompare, currency);
        priceAction.appendChild(oSpan);
      } else if (stickyOriginal) {
        stickyOriginal.textContent = formatDisplayMoney(effectiveCompare, currency);
      }
    } else {
      if (stickyOriginal) stickyOriginal.remove();
    }

    // Sync Mobile Sticky Bar Price
    var mobileStickyPrice = section.querySelector('#amolee-sticky-addon-price');
    var mobileStickyCompare = section.querySelector('.amolee-sticky-add-to-bag__compare-price');
    var mobileStickyPricesContainer = section.querySelector('.amolee-sticky-add-to-bag__prices');

    if (mobileStickyPrice) mobileStickyPrice.textContent = formatDisplayMoney(effectivePrice, currency);

    if (effectiveCompare && effectiveCompare > effectivePrice) {
      if (!mobileStickyCompare && mobileStickyPricesContainer) {
        var msCompare = document.createElement('span');
        msCompare.className = 'amolee-sticky-add-to-bag__compare-price';
        msCompare.textContent = formatDisplayMoney(effectiveCompare, currency);
        mobileStickyPricesContainer.appendChild(msCompare);
      } else if (mobileStickyCompare) {
        mobileStickyCompare.textContent = formatDisplayMoney(effectiveCompare, currency);
      }
    } else {
      if (mobileStickyCompare) mobileStickyCompare.remove();
    }

    // Dynamic Additional Savings & Discounted Price (Offer's info)
    updateOfferSavingsDisplay(effectivePrice, currency);
  }
  /*  AMOLIH CUSTOM PRICE DISPLAY END                                    */

  function updatePrices(variant) {
    if (!variant) return;

    // AMOLIH CUSTOM PRICE DISPLAY: localized price/compare/discount + sticky.
    refreshPriceDisplay(variant);

    // Add-to-cart button
    var addBtn = section.querySelector('.amolee-product-info__add-to-cart');
    if (addBtn) {
      addBtn.disabled = !variant.available;
      addBtn.textContent = variant.available ? 'ADD TO BAG' : 'SOLD OUT';
    }

    // Sync mobile sticky button
    var stickyBtn = section.querySelector('#amolee-sticky-add-to-bag-btn');
    if (stickyBtn) {
      stickyBtn.disabled = !variant.available;
      stickyBtn.textContent = variant.available ? 'ADD TO BAG' : 'SOLD OUT';
    }

    // Hidden variant ID
    var idInput = section.querySelector('input[name="id"]');
    if (idInput) idInput.value = variant.id;

    // Update image for variant
    updateVariantImage(variant);


    // Update title & description from variant metafields
    updateVariantMeta(variant);
    updateMetaTags(variant);

    // Recalculate add-on totals
    basePrice = variant.price;
    updatePriceWithAddons();

    syncWishlistButton(variant);
    updateDeliveryTimeline(variant);
    updateGridMedia();
  }

  /* ------------------------------------------------------------------ */
  /*  Update gallery when variant changes                                */
  /* ------------------------------------------------------------------ */
  function updateVariantImage(variant) {
    if (!variant || !productMedia || productMedia.length === 0) return;
    var fId = (variant.featured_media && variant.featured_media.id) || (variant.featured_image && variant.featured_image.id);
    var idx = -1;

    if (fId) {
      idx = productMedia.findIndex(function (m) {
        return String(m.id) === String(fId);
      });
    }

    if (idx === -1) {
      var vSrc = (variant.featured_media && (variant.featured_media.preview_image ? variant.featured_media.preview_image.src : variant.featured_media.src))
        || (variant.featured_image && (variant.featured_image.src || variant.featured_image))
        || '';
      if (vSrc && typeof vSrc === 'string') {
        var cleanVSrc = vSrc.split('?')[0].replace(/^https?:/, '');
        idx = productMedia.findIndex(function (m) {
          if (!m.src) return false;
          var cleanMSrc = m.src.split('?')[0].replace(/^https?:/, '');
          return cleanMSrc === cleanVSrc || cleanMSrc.endsWith(cleanVSrc) || cleanVSrc.endsWith(cleanMSrc);
        });
      }
    }

    if (idx === -1) return;

    var mediaItem = productMedia[idx];
    var isVideo = mediaItem && mediaItem.media_type === 'video';
    var videoSrc = '';
    if (isVideo) {
      var source = mediaItem.sources ? mediaItem.sources.find(function (s) { return s.format === 'mp4'; }) : null;
      videoSrc = source ? source.url : (mediaItem.sources && mediaItem.sources[0] ? mediaItem.sources[0].url : '');
    }

    // Extract variant-specific video_media metafield if available
    var meta = (variant && variantMeta[variant.id]) || {};
    var metaVideoSrc = meta.video_media || '';

    var mainVideo = document.getElementById('MainProductVideo');
    var videoToggle = document.querySelector('.view-video-toggle');
    if (mainVideo) {
      if (metaVideoSrc) {
        var cleanVideoSrc = metaVideoSrc.startsWith('//') ? window.location.protocol + metaVideoSrc : metaVideoSrc;
        if (mainVideo.src !== cleanVideoSrc) {
          mainVideo.src = cleanVideoSrc;
          mainVideo.load();
        }
        if (videoToggle) videoToggle.classList.remove('is-hidden');
      } else {
        mainVideo.pause();
        if (videoToggle) videoToggle.classList.add('is-hidden');
        if (activeVideoView) {
          toggleVideoView();
        }
      }
    }

    var imgUrl = mediaItem.src;
    originalSrc = imgUrl; // always track the current variant's image
    currentImageIndex = idx;

    // Update Mobile Main Image Thumbnail
    var mobileMainThumb = document.querySelector('.mobile-thumb-item.main-image-thumb');
    var mobileMainThumbImg = document.getElementById('MobileThumbMainImage');
    if (mobileMainThumb && mobileMainThumbImg && imgUrl) {
      mobileMainThumbImg.src = imgUrl;
      mobileMainThumb.dataset.imageSrc = imgUrl;
    }

    // Update Mobile Sticky Bar Thumbnail
    var mobileStickyThumb = section.querySelector('.amolee-sticky-add-to-bag__thumb');
    if (mobileStickyThumb && imgUrl) {
      mobileStickyThumb.src = imgUrl;
    }

    // Update Mobile Video Thumbnail
    var mobileVideoThumb = document.querySelector('.mobile-thumb-item.video-thumb');
    var mobileVideoThumbImg = document.getElementById('MobileThumbVideoImage');
    if (mobileVideoThumb) {
      var activeVideoSrc = metaVideoSrc || videoSrc;
      if (activeVideoSrc) {
        var cleanActiveVideoSrc = activeVideoSrc.startsWith('//') ? window.location.protocol + activeVideoSrc : activeVideoSrc;
        mobileVideoThumb.dataset.videoSrc = cleanActiveVideoSrc;
        if (mobileVideoThumbImg) {
          mobileVideoThumbImg.src = imgUrl; // Use main variant image as video poster
        }
        mobileVideoThumb.classList.remove('is-hidden');
      } else {
        mobileVideoThumb.classList.add('is-hidden');
        mobileVideoThumb.dataset.videoSrc = '';
      }
    }

    // Only update the displayed main image when NOT in model-view mode
    if (!activeSpecialView) {
      swapMainImage(imgUrl, null, mediaItem ? mediaItem.media_type : '', videoSrc);
    }

    syncActiveThumbnail();

    // Update image meta tags using the resolved productMedia src.
    // This is the ONLY place image meta tags are written — updateMetaTags()
    // intentionally does not touch them, so there is no overwrite race.
    var resolvedSrc = productMedia[idx].src;
    var httpSrc = resolvedSrc.startsWith('http') ? resolvedSrc : 'http:' + resolvedSrc;
    var httpsSrc = resolvedSrc.startsWith('https') ? resolvedSrc : 'https:' + resolvedSrc;
    var imageWidth = productMedia[idx].width || '';
    var imageHeight = productMedia[idx].height || '';

    var ogImage = document.querySelector('meta[property="og:image"]');
    if (ogImage) ogImage.setAttribute('content', httpSrc);

    var ogImageSecure = document.querySelector('meta[property="og:image:secure_url"]');
    if (ogImageSecure) ogImageSecure.setAttribute('content', httpsSrc);

    var ogImageWidth = document.querySelector('meta[property="og:image:width"]');
    if (ogImageWidth) ogImageWidth.setAttribute('content', imageWidth);

    var ogImageHeight = document.querySelector('meta[property="og:image:height"]');
    if (ogImageHeight) ogImageHeight.setAttribute('content', imageHeight);

    var twImage = document.querySelector('meta[name="twitter:image"]');
    if (twImage) twImage.setAttribute('content', httpsSrc);
  }

  /* ------------------------------------------------------------------ */
  /*  Update title & description from variant metafields                */
  /*  Falls back to product-level defaults from cfg (never DOM state)   */
  /* ------------------------------------------------------------------ */
  function updateVariantMeta(variant) {
    // variant may be null when no exact combination exists → always show product defaults
    var meta = (variant && variantMeta[variant.id]) || {};

    var titleEl = document.getElementById('amolee-product-title');
    if (titleEl) {
      titleEl.textContent = (meta.title && meta.title.trim()) ? meta.title : productTitle;
    }

    var descEl = document.getElementById('amolee-product-description');
    if (descEl) {
      // description is pre-rendered HTML by Shopify's metafield_tag filter
      descEl.innerHTML = (meta.description && meta.description.trim())
        ? meta.description
        : productDescription;

      // Append India-only price breakdown (additional_charges) when visitor is from India
      if (cfg.countryCode === 'IN' && meta.additional_charges && meta.additional_charges.trim()) {
        descEl.innerHTML += meta.additional_charges;
      }
    }

    // Keep hidden form input in sync so the variant title is submitted with the cart
    var variantTitleInput = section.querySelector('#property-variant-title');
    if (variantTitleInput) {
      variantTitleInput.value = (meta.title && meta.title.trim()) ? meta.title : '';
    }
  }

  /* ------------------------------------------------------------------ */
  /*  URL update with variant & option params                            */
  /* ------------------------------------------------------------------ */
  function updateURL(variant) {
    if (!variant) return;
    var url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);

    if (form) {
      form.querySelectorAll('input[type="radio"]:checked').forEach(function (radio) {
        var pos = radio.dataset.optionPosition;
        if (!pos) return;
        var val = radio.value;
        if (radio.closest('.amolee-metal-selector')) {
          url.searchParams.set('metaltype', val);
        } else if (radio.closest('.amolee-size-selector')) {
          url.searchParams.set('size', val);
        } else {
          url.searchParams.set('option' + pos, val);
        }
      });
    }

    if (url.href !== window.location.href) {
      history.replaceState({}, '', url.toString());
    }
  }

  function getSpecialViewLabel(type) {
    var btn = document.querySelector('[data-view-type="' + type + '"]');
    return btn ? btn.querySelector('span') : null;
  }

  function resetSpecialViewLabels() {
    Object.keys(specialViewMap).forEach(function (type) {
      var label = getSpecialViewLabel(type);
      if (label) label.innerText = specialViewMap[type].defaultLabel;
    });
  }

  function enterSpecialView(type) {
    var viewCfg = specialViewMap[type];
    if (!viewCfg || !viewCfg.src) return;

    if (activeVideoView) {
      var video = document.getElementById('MainProductVideo');
      var frame = document.querySelector('.main-image-frame');
      var btn = document.querySelector('.view-video-toggle span');
      activeVideoView = false;
      if (video) video.style.display = 'none';
      if (frame) frame.classList.remove('show-video');
      if (btn) btn.innerText = '3D view';
    }

    activeSpecialView = type;
    resetSpecialViewLabels();

    var label = getSpecialViewLabel(type);
    if (label) label.innerText = 'View Product';

    swapMainImage(viewCfg.src);
    syncActiveThumbnail();
  }

  function showVideoOnMainStage(videoSrc) {
    if (activeSpecialView) {
      activeSpecialView = '';
      resetSpecialViewLabels();
    }

    activeVideoView = true;
    var video = document.getElementById('MainProductVideo');
    var videoContainer = video ? video.closest('.grid-item--video') : null;
    var mainImgContainer = document.querySelector('.grid-item--image');
    var specialImg = document.getElementById('SpecialProductImage');
    var frame = document.querySelector('.main-image-frame');

    if (specialImg) specialImg.style.display = 'none';
    if (mainImgContainer) mainImgContainer.style.display = 'none';

    if (video && videoSrc) {
      var normalizeVideoSrc = videoSrc.startsWith('//') ? window.location.protocol + videoSrc : videoSrc;
      if (video.src !== normalizeVideoSrc) {
        video.src = normalizeVideoSrc;
        video.load();
      }
      if (videoContainer) videoContainer.style.display = 'block';
      video.style.display = 'block';
      video.play().catch(function (e) { });
    }
    if (frame) frame.classList.add('show-video');
    syncActiveThumbnail();
  }

  function syncActiveThumbnail(clickedThumb) {
    var mobileThumbs = document.querySelectorAll('.mobile-thumb-item');
    mobileThumbs.forEach(function (el) {
      el.classList.remove('is-active');
    });

    if (clickedThumb) {
      clickedThumb.classList.add('is-active');
    } else {
      if (activeSpecialView === 'side_view') {
        var svThumb = document.querySelector('.mobile-thumb-item.side-view-thumb');
        if (svThumb) svThumb.classList.add('is-active');
      } else if (activeSpecialView === 'top_view') {
        var tvThumb = document.querySelector('.mobile-thumb-item.top-view-thumb');
        if (tvThumb) tvThumb.classList.add('is-active');
      } else if (activeSpecialView === 'model') {
        var mThumb = document.querySelector('.mobile-thumb-item.model-thumb');
        if (mThumb) mThumb.classList.add('is-active');
      } else if (activeSpecialView === 'dimension') {
        var dThumb = document.querySelector('.mobile-thumb-item.dimension-thumb');
        if (dThumb) dThumb.classList.add('is-active');
      } else if (activeSpecialView === 'packaging') {
        var pThumb = document.querySelector('.mobile-thumb-item.packaging-thumb');
        if (pThumb) pThumb.classList.add('is-active');
      } else if (activeSpecialView === 'certificate') {
        var cThumb = document.querySelector('.mobile-thumb-item.certificate-thumb');
        if (cThumb) cThumb.classList.add('is-active');
      } else if (activeVideoView) {
        var vThumb = document.querySelector('.mobile-thumb-item.video-thumb');
        if (vThumb) vThumb.classList.add('is-active');
      } else {
        var mainThumb = document.querySelector('.mobile-thumb-item.main-image-thumb');
        if (mainThumb) mainThumb.classList.add('is-active');
      }
    }
  }

  function exitSpecialView() {
    var video = document.getElementById('MainProductVideo');
    var videoContainer = video ? video.closest('.grid-item--video') : null;
    var mainImgContainer = document.querySelector('.grid-item--image');
    var specialImg = document.getElementById('SpecialProductImage');
    var frame = document.querySelector('.main-image-frame');
    var btn = document.querySelector('.view-video-toggle span');

    if (activeVideoView) {
      activeVideoView = false;
      if (video) {
        video.pause();
        video.style.display = 'none';
      }
      if (videoContainer) videoContainer.style.display = 'none';
      if (frame) frame.classList.remove('show-video');
      if (btn) btn.innerText = '3D view';
    }

    if (frame) {
      frame.classList.remove('is-special-view');
      frame.classList.remove('show-video');
      frame.classList.remove('has-video-grid');
      var wrapper = frame.closest('.main-image-wrapper');
      if (wrapper) {
        wrapper.classList.remove('is-lifestyle-view');
        wrapper.classList.remove('has-video-grid');
      }
    }

    if (specialImg) {
      specialImg.style.display = 'none';
      specialImg.src = '';
    }

    if (mainImgContainer) {
      mainImgContainer.style.display = 'block';
    }

    activeSpecialView = '';
    resetSpecialViewLabels();

    var mainImg = document.getElementById('MainProductImage');
    if (mainImg && originalSrc) {
      mainImg.src = originalSrc;
    }

    syncActiveThumbnail();
  }

  // Listen for option radio changes inside the product form
  if (form) {
    form.addEventListener('change', function (e) {
      if (e.target.type !== 'radio') return;
      exitSpecialView();

      // Always remove is-lifestyle-view class when changing variant
      var wrapper = document.querySelector('.main-image-wrapper');
      if (wrapper) {
        wrapper.classList.remove('is-lifestyle-view');
      }

      var selected = getSelectedOptions();
      var match = findMatchingVariant(selected);
      if (match) {
        updatePrices(match);
        updateURL(match);
        // updatePrices already called updateVariantImage (image meta tags) then
        // updateMetaTags (title/desc/price/url tags) in the correct order.
        // Only og:url needs a refresh here because history.replaceState just ran.
        var ogUrl = document.querySelector('meta[property="og:url"]');
        if (ogUrl) ogUrl.setAttribute('content', window.location.href);
      } else {
        // No exact variant for this combination — always reset title/description
        // to product defaults so custom meta never bleeds through
        updateVariantMeta(null);
        updateMetaTags(null);
        // Still update the gallery image using the closest partial match
        // (first variant that has the newly-selected option value)
        var changedPos = parseInt(e.target.dataset.optionPosition, 10);
        var changedVal = e.target.value;
        if (!isNaN(changedPos)) {
          var partialMatch = variantsData.find(function (v) {
            return v.options[changedPos - 1] === changedVal;
          });
          if (partialMatch) updateVariantImage(partialMatch);
        }
      }

      // Visual is-selected state
      var label = e.target.closest('[class*="-selector__option"]');
      if (label) {
        var group = label.closest('.amolee-product-info__option-group');
        if (group) {
          group.querySelectorAll('[class*="-selector__option"]').forEach(function (opt) {
            opt.classList.remove('is-selected');
          });
          label.classList.add('is-selected');
        }
      }

      filterThumbnails();
    });
  }

  /* ================================================================== */
  /*  GALLERY LOGIC                                                      */
  /* ================================================================== */
  var currentImageIndex = 0;

  function changeMainImage(src, thumbElement) {
    var mediaType = thumbElement ? thumbElement.dataset.mediaType : '';
    var videoSrc = thumbElement ? thumbElement.dataset.videoSrc : '';

    if (window.innerWidth > 768) {
      // On desktop, secondary media is displayed in dedicated cards in the 2x2 grid.
      // Slot 1 should always remain the variant's main product image.
      exitSpecialView();
      updateGridMedia();
      return;
    }

    if (mediaType === 'side_view') {
      enterSpecialView('side_view');
    } else if (mediaType === 'top_view') {
      enterSpecialView('top_view');
    } else if (mediaType === 'model') {
      enterSpecialView('model');
    } else if (mediaType === 'dimension') {
      enterSpecialView('dimension');
    } else if (mediaType === 'packaging') {
      enterSpecialView('packaging');
    } else if (mediaType === 'certificate') {
      enterSpecialView('certificate');
    } else if (mediaType === 'video') {
      showVideoOnMainStage(videoSrc);
    } else {
      originalSrc = src;
      exitSpecialView();
      swapMainImage(src, null, mediaType, videoSrc);
    }

    syncActiveThumbnail(thumbElement);

    if (mediaType !== 'side_view' && mediaType !== 'top_view' && mediaType !== 'model' && mediaType !== 'dimension' && mediaType !== 'packaging' && mediaType !== 'certificate' && mediaType !== 'video') {
      syncVariantFromMediaId(thumbElement && thumbElement.dataset ? thumbElement.dataset.mediaId : null);
    }
  }

  var activeSpecialView = '';

  /* ------------------------------------------------------------------ */
  /*  Smooth image swap: preload → crossfade, no layout reflow           */
  /* ------------------------------------------------------------------ */
  function swapMainImage(newSrc, onDone, mediaType, videoSrc) {
    var specialImg = document.getElementById('SpecialProductImage');
    var video = document.getElementById('MainProductVideo');
    var videoContainer = video ? video.closest('.grid-item--video') : null;
    var mainImg = document.getElementById('MainProductImage');
    var mainImgContainer = mainImg ? mainImg.closest('.grid-item--image') : null;
    var frame = document.querySelector('.main-image-frame');

    if (activeSpecialView) {
      if (frame) {
        frame.classList.add('is-special-view');
        frame.classList.remove('has-video-grid');
        var wrapper = frame.closest('.main-image-wrapper');
        if (wrapper) wrapper.classList.remove('has-video-grid');
      }
      if (mainImgContainer) mainImgContainer.style.display = 'none';
      if (videoContainer) videoContainer.style.display = 'none';
      if (video) video.pause();

      if (specialImg) {
        specialImg.src = newSrc;
        specialImg.style.display = 'block';
      }
      if (onDone) onDone();
      return;
    } else {
      if (frame) {
        frame.classList.remove('is-special-view');
      }
      if (specialImg) specialImg.style.display = 'none';
      if (!activeVideoView) {
        if (mainImgContainer) mainImgContainer.style.display = 'block';
      }
    }

    updateGridMedia(newSrc);
    if (onDone) onDone();
  }

  function toggleSpecialImage(type) {
    var viewCfg = specialViewMap[type];
    if (!viewCfg) return;

    if (window.innerWidth <= 768) {
      activeSpecialView = type;
      resetSpecialViewLabels();
      var label = getSpecialViewLabel(type);
      if (label) label.innerText = 'View Product';
      swapMainImage(viewCfg.src);
      syncActiveThumbnail();
    } else {
      if (activeSpecialView === type) {
        // Toggle back to original product image
        activeSpecialView = '';
        resetSpecialViewLabels();
        swapMainImage(originalSrc);
        syncActiveThumbnail();
        return;
      }

      if (!viewCfg.src) return;

      activeSpecialView = type;
      resetSpecialViewLabels();

      var label = getSpecialViewLabel(type);
      if (label) label.innerText = 'View Product';

      swapMainImage(viewCfg.src);
      syncActiveThumbnail();
    }
  }

  var activeVideoView = false;
  function toggleVideoView() {
    var video = document.getElementById('MainProductVideo');
    var frame = document.querySelector('.main-image-frame');
    var btn = document.querySelector('.view-video-toggle span');

    if (activeVideoView) {
      activeVideoView = false;
      if (video) video.style.display = 'none';
      if (frame) frame.classList.remove('show-video');
      if (btn) btn.innerText = '3D view';
    } else {
      activeVideoView = true;
      exitSpecialView();
      if (video) {
        video.style.display = 'block';
        video.play().catch(function (e) { });
      }
      if (frame) frame.classList.add('show-video');
      if (btn) btn.innerText = 'View Product';
    }
    syncActiveThumbnail();
  }

  function toggleLifestyleImage() {
    toggleSpecialImage('model');
  }

  function toggleDimensionImage() {
    toggleSpecialImage('dimension');
  }

  // Event delegation for gallery actions (replaces onclick attributes)
  document.addEventListener('click', function (e) {
    var target = e.target.closest('[data-action]');
    if (!target) return;
    var action = target.dataset.action;

    if (action === 'change-image') {
      changeMainImage(target.dataset.imageSrc, target);
    } else if (action === 'toggle-lifestyle') {
      toggleLifestyleImage();
    } else if (action === 'toggle-dimension') {
      toggleDimensionImage();
    } else if (action === 'toggle-video') {
      toggleVideoView();
    }

    // Add/remove no-padding class based on active view toggle
    var wrapper = document.querySelector('.main-image-wrapper');
    if (wrapper) {
      var dimensionBtn = document.querySelector('.view-dimension-toggle span');
      var modelBtn = document.querySelector('.view-model-toggle span');

      // Dimension is active when button says "View Product" (toggle has already flipped)
      // Model is active when button says something other than "View on Model"
      var isDimensionActive = dimensionBtn && dimensionBtn.textContent.trim() === 'View Product';
      var isModelActive = modelBtn && modelBtn.textContent.trim() !== 'View on Model';

      if (isDimensionActive || isModelActive || activeVideoView) {
        wrapper.classList.add('is-lifestyle-view');
      } else {
        wrapper.classList.remove('is-lifestyle-view');
      }
    }
  });

  /* ================================================================== */
  /*  OPTION SELECTOR LOGIC (unified for metal, gemstone, generic)       */
  /* ================================================================== */

  /**
   * Inject images from a JSON hidden input into option placeholders.
   * Works for both gemstone and metal selectors.
   */
  function injectOptionImages(jsonInputId, optionSelector, nameAttr) {
    var jsonInput = document.getElementById(jsonInputId);
    if (!jsonInput) return;

    var images = {};
    try {
      var v = jsonInput.value;
      if (v) images = JSON.parse(v);
    } catch (e) { return; }

    section.querySelectorAll(optionSelector + '[data-option-value-name]').forEach(function (option) {
      var name = option.dataset.optionValueName;
      var wrapper = option.querySelector('[class*="-selector__image-wrapper"]');
      var placeholder = wrapper ? wrapper.querySelector('[class*="-selector__placeholder"]') : null;

      if (images[name] && wrapper && placeholder) {
        var img = document.createElement('img');
        img.src = images[name];
        img.alt = name;
        img.className = wrapper.className.replace('__image-wrapper', '__image');
        img.loading = 'lazy';
        placeholder.replaceWith(img);
      }
    });
  }

  injectOptionImages('gemstone-images-json', '.amolee-gemstone-selector__option', 'optionValueName');
  injectOptionImages('metal-images-json', '.amolee-metal-selector__option', 'optionValueName');

  /**
   * Initialise scroll-navigation and selection behaviour for one option group.
   */
  function initOptionSelector(group) {
    var track = group.querySelector('[class*="-selector__track"]');
    var trackIdx = track ? track.getAttribute('data-track-index') : '1';
    var options = group.querySelectorAll('[class*="-selector__option"][data-option-index="' + trackIdx + '"]');
    var prevBtn = group.querySelector('[class*="-selector__nav--prev"][data-option-index="' + trackIdx + '"]');
    var nextBtn = group.querySelector('[class*="-selector__nav--next"][data-option-index="' + trackIdx + '"]');
    var display = group.querySelector('[id*="selected-"][id*="-display-"]');

    var scrollPos = track ? track.scrollLeft : 0;

    function getScrollAmount() {
      if (!track) return 120;
      return Math.max(120, Math.round(track.clientWidth * 0.75));
    }

    function updateNavButtons() {
      if (!prevBtn || !nextBtn) return;
      if (!track) {
        prevBtn.disabled = true;
        nextBtn.disabled = true;
        return;
      }
      scrollPos = track.scrollLeft;
      var maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
      var hasOverflow = track.scrollWidth > track.clientWidth + 1;
      prevBtn.disabled = !hasOverflow || scrollPos <= 0;
      nextBtn.disabled = !hasOverflow || scrollPos >= maxScroll - 1;
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        scrollPos = Math.max(0, (track ? track.scrollLeft : scrollPos) - getScrollAmount());
        track.scrollTo({ left: scrollPos, behavior: 'smooth' });
        updateNavButtons();
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        var maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
        scrollPos = Math.min(maxScroll, (track ? track.scrollLeft : scrollPos) + getScrollAmount());
        track.scrollTo({ left: scrollPos, behavior: 'smooth' });
        updateNavButtons();
      });
    }

    if (track) {
      track.addEventListener('scroll', updateNavButtons, { passive: true });
      window.addEventListener('resize', updateNavButtons);
    }

    options.forEach(function (option) {
      function handleOptionSelect(e) {
        var radio = option.querySelector('input[type="radio"]');
        var valueName = option.dataset.value;

        if (display && valueName) display.textContent = valueName;

        options.forEach(function (opt) { opt.classList.remove('is-selected'); });
        option.classList.add('is-selected');

        if (radio) {
          if (!radio.checked) {
            radio.checked = true;
          }
          radio.dispatchEvent(new Event('change', { bubbles: true }));
        }

        // Auto-scroll selected option into view
        if (track) {
          var optLeft = option.offsetLeft;
          var optWidth = option.offsetWidth;
          var trackLeft = track.scrollLeft;
          var trackW = track.offsetWidth;

          if (optLeft < trackLeft) {
            track.scrollTo({ left: Math.max(0, optLeft - 10), behavior: 'smooth' });
            scrollPos = Math.max(0, optLeft - 10);
          } else if (optLeft + optWidth > trackLeft + trackW) {
            track.scrollTo({ left: Math.max(0, optLeft + optWidth - trackW + 10), behavior: 'smooth' });
            scrollPos = Math.max(0, optLeft + optWidth - trackW + 10);
          }
          updateNavButtons();
        }
      }

      option.addEventListener('click', handleOptionSelect);
    });

    // Mark initially-checked option
    var checked = group.querySelector('[class*="-selector__option"] input:checked');
    if (checked) {
      var checkedLabel = checked.closest('[class*="-selector__option"]');
      checkedLabel.classList.add('is-selected');
      if (display) display.textContent = checkedLabel.dataset.value;

      if (track && checkedLabel) {
        setTimeout(function () {
          var oLeft = checkedLabel.offsetLeft;
          var oWidth = checkedLabel.offsetWidth;
          var tWidth = track.offsetWidth;
          var tScrollLeft = track.scrollLeft;
          if (oLeft < tScrollLeft || oLeft + oWidth > tScrollLeft + tWidth) {
            var center = oLeft - (tWidth / 2) + (oWidth / 2);
            track.scrollTo({ left: Math.max(0, center), behavior: 'smooth' });
            scrollPos = Math.max(0, center);
            updateNavButtons();
          }
        }, 100);
      }
    }

    requestAnimationFrame(updateNavButtons);
  }

  // Initialise every option group in the section (metal, gemstone, carat-weight, etc.)
  section.querySelectorAll('.amolee-product-info__option-group').forEach(function (group) {
    if (group.classList.contains('amolee-size-selector') || group.classList.contains('amolee-addons')) return;

    if (group.classList.contains('amolee-gemstone-selector') && cfg.gemstoneHide) {
      group.style.display = 'none';
      var prev = group.previousElementSibling;
      if (prev && prev.classList.contains('amolee-product-info__option-divider')) {
        prev.style.display = 'none';
      }
      return;
    }

    initOptionSelector(group);
  });

  /* ================================================================== */
  /*  SIZE SELECTOR                                                      */
  /* ================================================================== */
  section.querySelectorAll('.amolee-size-selector').forEach(function (sizeSelector) {
    var sizeType = sizeSelector.dataset.sizeType || '';

    // Hide the size selector and its preceding divider if the metafield flag is true
    var shouldHide = false;
    if (sizeType === 'ring' && cfg.ringSizeHide) {
      shouldHide = true;
    } else if (sizeType === 'bracelet' && cfg.braceletSizeHide) {
      shouldHide = true;
    }

    if (shouldHide) {
      sizeSelector.style.display = 'none';
      var prev = sizeSelector.previousElementSibling;
      if (prev && prev.classList.contains('amolee-product-info__option-divider')) {
        prev.style.display = 'none';
      }
      return;
    }

    var display = document.getElementById('selected-' + sizeType + '-display');
    var propInput = section.querySelector('#property-size');

    function updateSizeSelected() {
      var checked = sizeSelector.querySelector('input[type="radio"]:checked');

      // Update display label (e.g. "Select Size: 7")
      if (display) {
        display.textContent = checked ? ' ' + checked.value : '';
      }

      // Toggle is-selected class on option buttons
      sizeSelector.querySelectorAll('.amolee-size-selector__option').forEach(function (opt) {
        opt.classList.remove('is-selected');
        opt.setAttribute('aria-pressed', 'false');
      });
      if (checked) {
        var btn = checked.closest('.amolee-size-selector__option');
        if (btn) {
          btn.classList.add('is-selected');
          btn.setAttribute('aria-pressed', 'true');
        }
      }

      // Sync hidden cart property
      if (propInput && checked) {
        propInput.value = checked.value;
      }
    }

    // Button click handler
    sizeSelector.querySelectorAll('.amolee-size-selector__option').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        var radio = btn.querySelector('input[type="radio"]');
        if (radio && !radio.checked) {
          radio.checked = true;
          radio.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    });

    // Also listen for radio changes (keyboard accessibility)
    sizeSelector.querySelectorAll('input[type="radio"][name="' + sizeType + '_size"]').forEach(function (radio) {
      radio.addEventListener('change', updateSizeSelected);
    });

    // Initialise on page load
    updateSizeSelected();
  });

  /* ================================================================== */
  /*  ACCENT STONE SELECTOR                                              */
  /* ================================================================== */
  var accentStoneInputs = section.querySelectorAll('.accent-stone-selector__input');
  var accentStoneProp = section.querySelector('#property-accent-stone');
  var accentStonePriceProp = section.querySelector('#property-accent-stone-price');
  /*
   * Header display element — shows selected display name beside the label,
   * e.g. "Accent Stone: Lab Grown Diamond". Mirrors the Size selector pattern.
   * Lives in the Liquid as:
   *   <span class="accent-stone-selector__selected" id="accent-stone-selected-display"></span>
   */
  var accentStoneHeaderDisplay = document.getElementById('accent-stone-selected-display');

  function normalizeStoneName(name) {
    return (name || '').toString().trim().toLowerCase().replace(/[-_]/g, ' ');
  }

  function isStoneMatch(nameA, nameB) {
    var a = normalizeStoneName(nameA);
    var b = normalizeStoneName(nameB);
    if (!a || !b) return false;
    if (a === b) return true;
    var aIsLab = (a === 'lab grown' || a === 'lab grown diamond');
    var bIsLab = (b === 'lab grown' || b === 'lab grown diamond');
    if (aIsLab && bIsLab) return true;
    var aIsNat = (a === 'natural' || a === 'natural diamond');
    var bIsNat = (b === 'natural' || b === 'natural diamond');
    if (aIsNat && bIsNat) return true;
    return false;
  }

  function findStoneByName(name) {
    var target = normalizeStoneName(name);
    if (!target) return null;
    return accentStonePricing.find(function (stone) {
      return stone && isStoneMatch(stone.name, target);
    }) || null;
  }

  function getStoneUnitPriceCents(stone, inputFallback) {
    if (!stone) return 0;
    var region = (cfg.countryCode || '').toUpperCase();
    var isIndia = (region === 'IN' || activeCurrency === 'INR');
    var price = null;
    if (region === 'IN') {
      price = stone.price_india;
    } else if (region === 'US' || region === 'ROW') {
      price = stone.price_us;
    } else if (region === 'UK' || region === 'GB') {
      price = stone.price_uk;
    }
    if (price === null || price === undefined || price === '') {
      price = stone.price_intl || stone.price_international || stone.price || stone.price_uk || stone.price_us;
    }
    if (price !== undefined && price !== null && price !== '') {
      var p = parseFloat(price);
      if (isIndia) {
        p = Math.round(p);
      }
      return Math.round(p * 100);
    }
    if (inputFallback && inputFallback.dataset && inputFallback.dataset.price) {
      var parsed = parseMoneyAmountToCents(inputFallback.dataset.price);
      if (isIndia) {
        parsed = Math.round(parsed / 100) * 100;
      }
      return parsed;
    }
    return 0;
  }

  function ensureAccentStoneSelection() {
    if (!accentStoneInputs.length) return;

    var hasChecked = Array.prototype.some.call(accentStoneInputs, function (input) {
      return input.checked;
    });
    if (hasChecked) return;

    var defaultNameInput = Array.prototype.find.call(accentStoneInputs, function (input) {
      return isStoneMatch(input.value, accentStoneDefaultName);
    });

    var defaultInput = defaultNameInput || accentStoneInputs[0];
    if (defaultInput) defaultInput.checked = true;
  }

  /*
   * updateAccentStoneHeaderDisplay
   * Reads data-display-name from the checked radio and writes it to the
   * header span so the user sees e.g. "Accent Stone: Lab Grown Diamond".
   * The raw input.value (e.g. "Lab Grown") is never changed — cart logic
   * (syncAccentStoneSelection → findStoneByName → accentStoneProp) always
   * uses input.value, which matches stone.name from the JSON island.
   */
  function updateAccentStoneHeaderDisplay(checkedInput) {
    if (!accentStoneHeaderDisplay) return;
    if (!checkedInput) {
      accentStoneHeaderDisplay.textContent = '';
      return;
    }
    // Prefer data-display-name (set in Liquid); fall back to raw value
    var displayName = (checkedInput.dataset.displayName || checkedInput.value || '').trim();
    accentStoneHeaderDisplay.textContent = displayName ? ' ' + displayName : '';
  }

  function syncAccentStoneSelection() {
    if (!accentStoneInputs.length) return;

    ensureAccentStoneSelection();

    var selectedInput = Array.prototype.find.call(accentStoneInputs, function (input) {
      return input.checked;
    });

    // ── Display name in header (purely visual, no effect on cart value) ──
    updateAccentStoneHeaderDisplay(selectedInput);

    // ── Everything below is unchanged: uses input.value (raw name) ──
    var selectedName = selectedInput && selectedInput.value ? selectedInput.value.trim() : '';
    var selectedStone = findStoneByName(selectedName);
    var defaultStone = findStoneByName(accentStoneDefaultName);
    var defaultInput = Array.prototype.find.call(accentStoneInputs, function (input) {
      return isStoneMatch(input.value, accentStoneDefaultName);
    });
    var selectedInputFallback = selectedInput;

    var selectedPrice = getStoneUnitPriceCents(selectedStone, selectedInputFallback);
    var defaultPrice = getStoneUnitPriceCents(defaultStone, defaultInput);

    // If selected is default, price adjustment is 0
    // If not, subtract default and add selected
    accentStonePrice = 0;
    if (!isStoneMatch(selectedName, accentStoneDefaultName)) {
      accentStonePrice = selectedPrice - defaultPrice;
      if (activeCurrency === 'INR' || (cfg.countryCode || '').toUpperCase() === 'IN') {
        accentStonePrice = Math.round(accentStonePrice / 100) * 100;
      }
    }

    // Cart hidden inputs: raw name and price delta
    if (accentStoneProp) accentStoneProp.value = selectedName;
    if (accentStonePriceProp) accentStonePriceProp.value = accentStonePrice !== 0 ? formatMoney(accentStonePrice) : '';

    updatePriceWithAddons();
  }

  if (accentStoneInputs.length) {
    accentStoneInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        // Update is-selected class on labels
        accentStoneInputs.forEach(function (i) {
          i.closest('label').classList.remove('is-selected');
        });
        this.closest('label').classList.add('is-selected');

        syncAccentStoneSelection();
      });
    });
    // Initialise on page load (sets header display + cart property)
    syncAccentStoneSelection();
  }

  /* ------------------------------------------------------------------ */
  /*  Inject engraving error input CSS                                   */
  /* ------------------------------------------------------------------ */
  (function () {
    var styleId = 'amolee-engraving-error-style';
    if (!document.getElementById(styleId)) {
      var style = document.createElement('style');
      style.id = styleId;
      style.textContent = [
        '.amolee-engraving-input--error {',
        '  border-color: #e53e3e !important;',
        '  box-shadow: 0 0 0 2px rgba(229,62,62,0.18) !important;',
        '  outline: none;',
        '}'
      ].join('\n');
      document.head.appendChild(style);
    }
  })();

  /* ================================================================== */
  /*  ENGRAVING ADD-ON                                                   */
  /* ================================================================== */
  var engravingCheckbox = section.querySelector('#addon-engraving');
  var engravingWrapper = section.querySelector('#engraving-input-wrapper');
  var engravingInputs = section.querySelectorAll('[data-engraving-input]');
  var engravingSummary = section.querySelector('#engraving-summary');
  var engravingSummaryList = section.querySelector('#engraving-summary-list');
  var engravingErrors = section.querySelector('#engraving-errors');
  var engravingPropertiesContainer = section.querySelector('#engraving-properties-container');
  var engravingActionsBar = section.querySelector('.amolee-addons__engraving-actions-bar');
  var engravingEdit = section.querySelector('#engraving-edit');
  var engravingRemove = section.querySelector('#engraving-remove');
  var engravingToggleLabel = section.querySelector('.amolee-addons__toggle[for="addon-engraving"]');
  var engravingSubmitBtn = section.querySelector('#engraving-submit-btn');
  var engravingErrorTimer = null;

  var isEngravingExpanded = false;
  var engravingValue = '';

  function normalizeEngravingToken(token) {
    return String(token || '').trim().toLowerCase();
  }

  function resolveEngravingPlaceholder(template, label) {
    var source = String(template || '').trim();
    if (!source) return '';

    var tokenMap = {
      name: 'name',
      date: 'DDMMYYYY',
      message: 'message',
      initial: 'initial',
      initials: 'initials',
      year: 'YYYY',
      number: 'number'
    };

    return source.replace(/\{([^}]+)\}/g, function (_, rawToken) {
      var normalized = normalizeEngravingToken(rawToken);
      return tokenMap[normalized] || rawToken;
    });
  }

  function isValidDDMMYYYY(value) {
    var normalized = String(value || '').trim();
    if (!/^\d{8}$/.test(normalized)) return false;

    var day = parseInt(normalized.slice(0, 2), 10);
    var month = parseInt(normalized.slice(2, 4), 10);
    var year = parseInt(normalized.slice(4, 8), 10);

    if (month < 1 || month > 12) return false;
    if (day < 1) return false;

    var parsedDate = new Date(year, month - 1, day);
    return parsedDate.getFullYear() === year
      && parsedDate.getMonth() === month - 1
      && parsedDate.getDate() === day;
  }

  function isDDMMYYYYField(input, label, fieldType, maxChars) {
    if (fieldType !== 'numeric_field') return false;

    var combinedHint = [
      input && input.dataset ? input.dataset.placeholderTemplate : '',
      input ? input.placeholder : '',
      label
    ].join(' ').toLowerCase();

    if (combinedHint.indexOf('ddmmyyyy') !== -1) return true;
    if (combinedHint.indexOf('date') !== -1 && Number(maxChars) === 8) return true;
    return false;
  }

  function clearEngravingErrors() {
    if (engravingErrorTimer) {
      clearTimeout(engravingErrorTimer);
      engravingErrorTimer = null;
    }
    if (!engravingErrors) return;
    engravingErrors.textContent = '';
    engravingErrors.style.display = 'none';
  }

  function showEngravingErrors(messages) {
    if (!engravingErrors) return;
    if (!messages || !messages.length) {
      clearEngravingErrors();
      return;
    }
    engravingErrors.innerHTML = messages.map(function (msg) {
      return '<div>' + msg + '</div>';
    }).join('');
    engravingErrors.style.display = 'block';

    if (engravingErrorTimer) clearTimeout(engravingErrorTimer);
    engravingErrorTimer = setTimeout(function () {
      clearEngravingErrors();
    }, 5000);
  }

  function getEngravingInputLabel(input, index) {
    var label = input ? input.dataset.fieldLabel : '';
    if (!label || !label.trim()) {
      return 'Field ' + (index + 1);
    }
    return label.trim();
  }

  function syncEngravingProperties(entries) {
    if (!engravingPropertiesContainer) return;
    engravingPropertiesContainer.innerHTML = '';

    if (!entries || !entries.length) {
      engravingValue = '';
      return;
    }

    entries.forEach(function (entry) {
      var hiddenInput = document.createElement('input');
      hiddenInput.type = 'hidden';
      hiddenInput.name = 'properties[Engraving - ' + entry.label + ']';
      hiddenInput.value = entry.value;
      engravingPropertiesContainer.appendChild(hiddenInput);
    });

    var summaryInput = document.createElement('input');
    summaryInput.type = 'hidden';
    summaryInput.name = 'properties[Engraving Summary]';
    summaryInput.value = entries.map(function (entry) {
      return entry.label + ': ' + entry.value;
    }).join(' | ');
    engravingPropertiesContainer.appendChild(summaryInput);

    engravingValue = entries.map(function (entry) { return entry.value; }).join(' ').trim();
  }

  function renderEngravingSummary(entries) {
    if (!engravingSummaryList) return;
    engravingSummaryList.innerHTML = (entries || []).map(function (entry) {
      return '<div><strong>' + entry.label + ':</strong> ' + entry.value + '</div>';
    }).join('');
  }

  function clearEngravingValues() {
    engravingValue = '';
    if (engravingInputs && engravingInputs.length) {
      engravingInputs.forEach(function (input) {
        input.value = '';
        var row = input.closest('.amolee-addons__engraving-input-row');
        var counter = row ? row.querySelector('[data-char-count]') : null;
        if (counter) counter.textContent = '0';
      });
    }
    if (engravingSummaryList) engravingSummaryList.innerHTML = '';
    if (engravingPropertiesContainer) engravingPropertiesContainer.innerHTML = '';
    clearEngravingErrors();
  }

  function validateAndCollectEngraving(showErrors) {
    if (!engravingCheckbox || !engravingCheckbox.checked) {
      clearEngravingErrors();
      return { isValid: true, entries: [] };
    }

    var errors = [];
    var entries = [];

    if (!engravingInputs || !engravingInputs.length) {
      errors.push('Engraving is enabled but no engraving fields are configured.');
    } else {
      engravingInputs.forEach(function (input, index) {
        var rawValue = String(input.value || '');
        var trimmedValue = rawValue.trim();
        var label = getEngravingInputLabel(input, index);
        var minChars = parseInt(input.dataset.minChars || '0', 10);
        var maxChars = parseInt(input.dataset.maxChars || String(input.maxLength || 0), 10);
        var fieldType = String(input.dataset.fieldType || 'text_field').toLowerCase();
        var isRequired = String(input.dataset.required || 'true').toLowerCase() !== 'false';

        if (!trimmedValue) {
          if (isRequired) errors.push(label + ' is required.');
          return;
        }

        if (fieldType === 'numeric_field') {
          if (!/^\d+$/.test(trimmedValue)) {
            errors.push(label + ' must contain digits only.');
            return;
          }

          if (isDDMMYYYYField(input, label, fieldType, maxChars)) {
            if (trimmedValue.length !== 8) {
              errors.push(label + ' must be 8 digits in DDMMYYYY format.');
              return;
            }

            if (!isValidDDMMYYYY(trimmedValue)) {
              errors.push(label + ' must be a valid calendar date in DDMMYYYY format.');
              return;
            }
          }
        } else if (!/^[A-Za-z0-9\s.'&-]+$/.test(trimmedValue)) {
          errors.push(label + ' has invalid characters. Use letters, numbers, spaces, apostrophe, dot, ampersand, or hyphen only.');
          return;
        }

        if (!isNaN(minChars) && minChars > 0 && trimmedValue.length < minChars) {
          errors.push(label + ' must be at least ' + minChars + ' characters.');
          return;
        }

        if (!isNaN(maxChars) && maxChars > 0 && trimmedValue.length > maxChars) {
          errors.push(label + ' must be at most ' + maxChars + ' characters.');
          return;
        }

        entries.push({ label: label, value: trimmedValue });
      });
    }

    if (showErrors) {
      showEngravingErrors(errors);
    }

    return { isValid: errors.length === 0, entries: entries };
  }

  function saveEngravingSelection(showErrors) {
    var result = validateAndCollectEngraving(showErrors);
    if (!result.isValid) {
      if (engravingSummary) engravingSummary.style.display = 'none';
      if (engravingWrapper) engravingWrapper.style.display = 'block';
      isEngravingExpanded = true;
      return false;
    }

    syncEngravingProperties(result.entries);
    renderEngravingSummary(result.entries);

    if (!result.entries.length) {
      if (engravingSummary) engravingSummary.style.display = 'none';
      if (engravingWrapper) engravingWrapper.style.display = 'block';
      isEngravingExpanded = true;
    } else {
      if (engravingWrapper) engravingWrapper.style.display = 'none';
      if (engravingSummary) engravingSummary.style.display = 'flex';
      isEngravingExpanded = false;
    }

    updatePriceWithAddons();
    updateDeliveryTimeline();
    updateConfidenceReturnBadge();
    return true;
  }

  if (engravingInputs && engravingInputs.length) {
    engravingInputs.forEach(function (input) {
      var placeholder = resolveEngravingPlaceholder(input.dataset.placeholderTemplate || input.placeholder || '', input.dataset.fieldLabel || '');
      if (placeholder) input.placeholder = placeholder;

      input.addEventListener('input', function () {
        var fieldType = String(input.dataset.fieldType || 'text_field').toLowerCase();
        if (fieldType === 'numeric_field') {
          input.value = String(input.value || '').replace(/\D/g, '');
        }

        var row = input.closest('.amolee-addons__engraving-input-row');
        var counter = row ? row.querySelector('[data-char-count]') : null;
        if (counter) counter.textContent = String(input.value || '').length;

        // Remove error state when user starts typing
        input.classList.remove('amolee-engraving-input--error');
        clearEngravingErrors();
      });
    });

    if (engravingSubmitBtn && engravingActionsBar) {
      if (engravingSubmitBtn.parentElement !== engravingActionsBar) {
        engravingActionsBar.appendChild(engravingSubmitBtn);
      }
      engravingActionsBar.style.display = 'flex';
    }
  }

  if (engravingCheckbox) {
    engravingCheckbox.addEventListener('change', function () {
      if (this.checked && !engravingValue) {
        isEngravingExpanded = true;
        if (engravingWrapper) engravingWrapper.style.display = 'block';
        if (engravingSummary) engravingSummary.style.display = 'none';
        if (engravingInputs && engravingInputs[0]) engravingInputs[0].focus();
      } else if (!this.checked) {
        if (engravingWrapper) engravingWrapper.style.display = 'none';
        if (engravingSummary) engravingSummary.style.display = 'none';
        isEngravingExpanded = false;
        clearEngravingValues();
        updatePriceWithAddons();
      }
      updateDeliveryTimeline();
      updateConfidenceReturnBadge();
    });

    if (engravingToggleLabel) {
      engravingToggleLabel.addEventListener('click', function (e) {
        if (engravingCheckbox.checked && engravingValue) {
          e.preventDefault();
          isEngravingExpanded = !isEngravingExpanded;
          if (isEngravingExpanded) {
            if (engravingWrapper) engravingWrapper.style.display = 'block';
            if (engravingSummary) engravingSummary.style.display = 'none';
            if (engravingInputs && engravingInputs[0]) engravingInputs[0].focus();
          } else {
            if (engravingWrapper) engravingWrapper.style.display = 'none';
            if (engravingSummary) engravingSummary.style.display = 'flex';
          }
        }
      });
    }
  }

  if (engravingSubmitBtn) {
    engravingSubmitBtn.addEventListener('click', function () {
      if (engravingCheckbox && engravingCheckbox.checked) {
        saveEngravingSelection(true);
      }
    });
  }

  if (engravingEdit) {
    engravingEdit.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      isEngravingExpanded = true;
      if (engravingWrapper) engravingWrapper.style.display = 'block';
      if (engravingSummary) engravingSummary.style.display = 'none';
      if (engravingInputs && engravingInputs[0]) engravingInputs[0].focus();
    });
  }

  if (engravingRemove) {
    engravingRemove.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      clearEngravingValues();
      if (engravingSummary) engravingSummary.style.display = 'none';
      if (engravingWrapper) engravingWrapper.style.display = 'block';
      isEngravingExpanded = true;
      if (engravingInputs && engravingInputs[0]) engravingInputs[0].focus();
      updatePriceWithAddons();
      updateDeliveryTimeline();
      updateConfidenceReturnBadge();
    });
  }

  // Toggle plus/minus icon on all addon checkboxes
  var addonToggles = section.querySelectorAll('.amolee-addons__toggle');
  addonToggles.forEach(function (toggle) {
    var checkbox = toggle.querySelector('input[type="checkbox"]');
    var icon = toggle.querySelector('.amolee-addons__icon');
    checkbox.addEventListener('change', function () {
      if (this.checked) {
        icon.innerHTML = '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 7H13" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';
      } else {
        icon.innerHTML = '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7 1V13M1 7H13" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';
      }
    });
  });

  /* ================================================================== */
  /*  CERTIFICATE ADD-ON                                                 */
  /* ================================================================== */
  var certificateCheckbox = section.querySelector('#addon-certificate');
  var certAddonsWrapper = section.querySelector('#cert-addons-wrapper');
  var certRadios = section.querySelectorAll('.addon-radio');

  var certificatePrice = 0;
  var lastSelectedCertificate = null;
  var selectedCertificateProductId = null;

  if (certificateCheckbox && certAddonsWrapper) {
    certificateCheckbox.addEventListener('change', function () {
      if (this.checked) {
        certAddonsWrapper.style.display = 'block';
      } else {
        certAddonsWrapper.style.display = 'none';
        certRadios.forEach(function (r) { r.checked = false; });
        document.querySelectorAll('.addon-card').forEach(function (card) {
          card.classList.remove('is-selected');
          card.style.borderColor = '';
          card.style.borderWidth = '1px';
          card.style.backgroundColor = '';
          card.style.borderWidth = '';
        });
        lastSelectedCertificate = null;
        certificatePrice = 0;
        selectedCertificateProductId = null;
        var certDisp = section.querySelector('#certificate-display');
        if (certDisp) certDisp.style.display = 'none';
        updatePriceWithAddons();
      }
    });
  }

  certRadios.forEach(function (radio) {
    radio.addEventListener('click', function (e) {
      e.stopPropagation();
      if (lastSelectedCertificate === this) {
        e.preventDefault();
        this.checked = false;
        var pc = this.closest('.addon-card');
        if (pc) { pc.classList.remove('is-selected'); pc.style.borderColor = ''; pc.style.borderWidth = ''; pc.style.backgroundColor = ''; }
        var selfRadio = this;
        setTimeout(function () { selfRadio.checked = false; }, 0);
        lastSelectedCertificate = null;
        certificatePrice = 0;
        selectedCertificateProductId = null;
        updatePriceWithAddons();
      } else {
        document.querySelectorAll('.addon-card').forEach(function (card) {
          card.classList.remove('is-selected');
          card.style.borderColor = '';
          card.style.borderWidth = '1px';
          card.style.backgroundColor = '';
          card.style.borderWidth = '';
        });
        var pc = this.closest('.addon-card');
        this.checked = true;
        if (pc) { pc.classList.add('is-selected'); pc.style.borderColor = '#426E6D'; pc.style.borderWidth = '1px'; pc.style.backgroundColor = '#E8F0EF'; }
        lastSelectedCertificate = this;
        // AMOLIH CUSTOM PRICE DISPLAY: pick the data-price-{region} attribute
        // matching the visitor's region; fall back to native data-price (INR)
        // when the regional metafield is blank, same rule as the main price.
        certificatePrice = getAddonRegionPriceCents(this);
        selectedCertificateProductId = this.value;
        updatePriceWithAddons();
      }
    });
  });

  /* ================================================================== */
  /*  CHAIN ADD-ON                                                       */
  /* ================================================================== */
  var chainCheckbox = section.querySelector('#addon-chain');
  var chainCustomizer = section.querySelector('#chain-customizer');
  var chainDataEl = document.getElementById('chain-product-data');
  var chainPrice = 0;
  var selectedChainVariantId = null;
  var chainCfg = null;

  if (chainDataEl) {
    try { chainCfg = JSON.parse(chainDataEl.textContent); } catch (e) { chainCfg = null; }
  }

  if (chainCfg) {
    selectedChainVariantId = chainCfg.defaultVariantId;
    // Don't add chain price until checkbox is checked
  }

  /**
   * Find matching chain variant based on current select values
   */
  function findChainVariant() {
    if (!chainCfg || !chainCfg.variants) return null;
    var selects = section.querySelectorAll('.chain-addon__select');
    var selectedOpts = [];
    selects.forEach(function (sel) { selectedOpts.push(sel.value); });

    return chainCfg.variants.find(function (v) {
      return v.options.every(function (opt, idx) {
        return opt === selectedOpts[idx];
      });
    });
  }

  /**
   * Update chain addon label text & price based on selected variant
   */
  function updateChainDisplay(variant) {
    if (!variant) return;

    // Update circular preview image (ported from the old inline <script> in
    // chain-addon.liquid, removed to avoid a duplicate 'change' listener).
    var chainImageEl = document.getElementById('chain-addon-image');
    if (chainImageEl) {
      var chainImgUrl = '';
      if (variant.featured_media && variant.featured_media.preview_image && variant.featured_media.preview_image.src) {
        chainImgUrl = variant.featured_media.preview_image.src;
      } else if (variant.featured_media && variant.featured_media.src) {
        chainImgUrl = variant.featured_media.src;
      } else if (variant.featured_image) {
        chainImgUrl = variant.featured_image;
      } else if (chainCfg && chainCfg.featured_image) {
        chainImgUrl = chainCfg.featured_image;
      }
      if (chainImgUrl) {
        chainImageEl.src = chainImgUrl;
        chainImageEl.alt = variant.title || '';
      }
    }

    // AMOLIH CUSTOM PRICE DISPLAY: chain is its own product with its own
    // usd/gbp/cad/inr metafields (passed per-variant in chainCfg.variants).
    var display = getAddonRegionDisplay(variant, variant.price);
    var priceLabel = section.querySelector('#chain-addon-price-label');
    if (priceLabel) priceLabel.textContent = '+\u00A0' + formatDisplayMoney(display.minor, display.currency);

    var nameLabel = section.querySelector('.amolee-chain-addon .amolee-addons__item-label');
    if (nameLabel) {
      nameLabel.innerHTML = 'Add a Chain <br> <span style="font-size:12px; color:gray;">' + variant.title.replace(/ \/ /g, ' ') + '</span>';
    }

    selectedChainVariantId = variant.id;

    if (chainCheckbox && chainCheckbox.checked) {
      chainPrice = display.minor;
    }
    updatePriceWithAddons();
  }

  // Chain checkbox toggle
  if (chainCheckbox && chainCustomizer) {
    chainCheckbox.addEventListener('change', function () {
      if (this.checked) {
        chainCustomizer.style.display = 'block';
        var match = findChainVariant();
        if (match) {
          updateChainDisplay(match);
        } else if (chainCfg) {
          var defaultEntry = chainCfg.variants ? chainCfg.variants.find(function (v) { return v.id === chainCfg.defaultVariantId; }) : null;
          if (defaultEntry) {
            updateChainDisplay(defaultEntry);
          } else {
            chainPrice = getAddonRegionDisplay(null, chainCfg.defaultVariantPrice).minor;
            selectedChainVariantId = chainCfg.defaultVariantId;
            updatePriceWithAddons();
          }
        }
      } else {
        chainCustomizer.style.display = 'none';
        chainPrice = 0;
        selectedChainVariantId = null;
        updatePriceWithAddons();
      }
    });
  }

  // Chain option selects
  section.querySelectorAll('.chain-addon__select').forEach(function (select) {
    select.addEventListener('change', function () {
      var match = findChainVariant();
      if (match) {
        updateChainDisplay(match);
      } else {
        // No matching variant — show unavailable
        var priceLabel = section.querySelector('#chain-addon-price-label');
        if (priceLabel) priceLabel.textContent = 'Unavailable';
        chainPrice = 0;
        selectedChainVariantId = null;
        updatePriceWithAddons();
      }
    });
  });

  /* ================================================================== */
  /*  PUSH ADD-ON                                                       */
  /* ================================================================== */
  var pushCheckbox = section.querySelector('#addon-push');
  var pushCustomizer = section.querySelector('#push-customizer');
  var pushDataEl = document.getElementById('push-product-data');
  var pushPrice = 0;
  var selectedPushVariantId = null;
  var pushCfg = null;

  if (pushDataEl) {
    try { pushCfg = JSON.parse(pushDataEl.textContent); } catch (e) { pushCfg = null; }
  }

  if (pushCfg) {
    selectedPushVariantId = pushCfg.defaultVariantId;
    // Hide push variant selector if only one variant
    if (pushCfg.variants && pushCfg.variants.length === 1) {
      var pushSelects = section.querySelectorAll('.push-addon__select');
      pushSelects.forEach(function (sel) { sel.style.display = 'none'; });
      var pushNavs = section.querySelectorAll('.push-addon__nav');
      pushNavs.forEach(function (nav) { nav.style.display = 'none'; });
    }
    // Don't add push price until checkbox is checked
  }

  /**
   * Find matching push variant based on current select values
   */
  function findPushVariant() {
    if (!pushCfg || !pushCfg.variants) return null;
    var selects = section.querySelectorAll('.push-addon__select');
    var selectedOpts = [];
    selects.forEach(function (sel) { selectedOpts.push(sel.value); });

    return pushCfg.variants.find(function (v) {
      return v.options.every(function (opt, idx) {
        return opt === selectedOpts[idx];
      });
    });
  }

  /**
   * Update push addon label text & price based on selected variant
   */
  function updatePushDisplay(variant) {
    if (!variant) return;

    // Update circular preview image (ported from the old inline <script> in
    // push-addon.liquid, removed to avoid a duplicate 'change' listener).
    var pushImageEl = document.getElementById('push-addon-image');
    if (pushImageEl) {
      var pushImgUrl = '';
      if (variant.featured_media && variant.featured_media.preview_image && variant.featured_media.preview_image.src) {
        pushImgUrl = variant.featured_media.preview_image.src;
      } else if (variant.featured_media && variant.featured_media.src) {
        pushImgUrl = variant.featured_media.src;
      } else if (variant.featured_image) {
        pushImgUrl = variant.featured_image;
      } else if (pushCfg && pushCfg.featured_image) {
        pushImgUrl = pushCfg.featured_image;
      }
      if (pushImgUrl) {
        pushImageEl.src = pushImgUrl;
        pushImageEl.alt = variant.title || '';
      }
    }

    // AMOLIH CUSTOM PRICE DISPLAY: push is its own product with its own
    // usd/gbp/cad/inr metafields (passed per-variant in pushCfg.variants).
    var display = getAddonRegionDisplay(variant, variant.price);
    var priceLabel = section.querySelector('#push-addon-price-label');
    if (priceLabel) priceLabel.textContent = '+' + formatDisplayMoney(display.minor, display.currency);

    // NOTE: corrected selector — markup uses .amolee-addons__item-label
    // (the old .amolee-addons__item-name selector never matched anything).
    var nameLabel = section.querySelector('.amolee-push-addon .amolee-addons__item-label');
    if (nameLabel) {
      nameLabel.textContent = variant.title ? variant.title.replace(/ \/ /g, ' ') : '';
    }

    selectedPushVariantId = variant.id;

    if (pushCheckbox && pushCheckbox.checked) {
      pushPrice = display.minor;
    }
    updatePriceWithAddons();
  }

  // Push checkbox toggle
  if (pushCheckbox && pushCustomizer) {
    pushCheckbox.addEventListener('change', function () {
      if (this.checked) {
        // If only one push variant, hide customizer and just apply price
        if (pushCfg && pushCfg.variants && pushCfg.variants.length === 1) {
          pushCustomizer.style.display = 'none';
          updatePushDisplay(pushCfg.variants[0]);
        } else {
          pushCustomizer.style.display = 'block';
          var match = findPushVariant();
          if (match) {
            updatePushDisplay(match);
          } else if (pushCfg) {
            var defaultPushEntry = pushCfg.variants ? pushCfg.variants.find(function (v) { return v.id === pushCfg.defaultVariantId; }) : null;
            if (defaultPushEntry) {
              updatePushDisplay(defaultPushEntry);
            } else {
              pushPrice = getAddonRegionDisplay(null, pushCfg.defaultVariantPrice).minor;
              selectedPushVariantId = pushCfg.defaultVariantId;
              updatePriceWithAddons();
            }
          }
        }
      } else {
        pushCustomizer.style.display = 'none';
        pushPrice = 0;
        selectedPushVariantId = null;
        updatePriceWithAddons();
      }
    });
  }

  // Push option selects
  section.querySelectorAll('.push-addon__select').forEach(function (select) {
    select.addEventListener('change', function () {
      var match = findPushVariant();
      if (match) {
        updatePushDisplay(match);
      } else {
        // No matching variant — show unavailable
        var priceLabel = section.querySelector('#push-addon-price-label');
        if (priceLabel) priceLabel.textContent = 'Unavailable';
        pushPrice = 0;
        selectedPushVariantId = null;
        updatePriceWithAddons();
      }
    });
  });

  /* ------------------------------------------------------------------ */
  /*  Addon price aggregation                                            */
  /* ------------------------------------------------------------------ */
  function updatePriceWithAddons() {
    var currentVariant = getCurrentVariant();
    if (!currentVariant) return;
    // AMOLIH CUSTOM PRICE DISPLAY START
    // Base price is the localized display amount (minor units) for the region,
    // with native-INR fallback. Accent-stone, certificate, chain, and push
    // add-on deltas are each resolved via their own product's region
    // metafields (getStoneUnitPriceCents / getAddonRegionDisplay) before
    // being stored here, so every term below is already in the same
    // currency as `currency` — plain addition is safe.
    var display = getVariantDisplay(currentVariant);
    var currency = display.currency;
    var isIndia = (currency === 'INR' || (cfg.countryCode || '').toUpperCase() === 'IN');
    basePrice = Number(display.minor) || 0;
    // AMOLIH CUSTOM PRICE DISPLAY END
    var safeAccentStonePrice = Number(accentStonePrice) || 0;
    var safeCertificatePrice = Number(certificatePrice) || 0;
    var safeChainPrice = Number(chainPrice) || 0;
    var safePushPrice = Number(pushPrice) || 0;

    if (isIndia) {
      basePrice = Math.round(basePrice / 100) * 100;
      safeAccentStonePrice = Math.round(safeAccentStonePrice / 100) * 100;
      safeCertificatePrice = Math.round(safeCertificatePrice / 100) * 100;
      safeChainPrice = Math.round(safeChainPrice / 100) * 100;
      safePushPrice = Math.round(safePushPrice / 100) * 100;
    }

    var productPriceWithAccent = basePrice + safeAccentStonePrice;
    var total = productPriceWithAccent + safeCertificatePrice + safeChainPrice + safePushPrice;

    // Main product price should change only for accent stone adjustments
    var mainPriceEl = section.querySelector('.amolee-product-info__price');
    if (mainPriceEl) mainPriceEl.textContent = formatDisplayMoney(productPriceWithAccent, currency);

    // Update compare-at and discount badge for product price with accent stone
    var comparePriceElement = section.querySelector('.amolee-product-info__compare-price');
    var discountBadge = section.querySelector('.amolee-product-info__discount-badge');
    var priceBlock = section.querySelector('.amolee-product-info__price-block');
    var effectiveCompare = display.compareMinor ? (display.compareMinor + safeAccentStonePrice) : 0;
    if (isIndia && effectiveCompare) {
      effectiveCompare = Math.round(effectiveCompare / 100) * 100;
    }

    if (effectiveCompare && effectiveCompare > productPriceWithAccent) {
      if (!comparePriceElement && priceBlock) {
        var cSpan = document.createElement('span');
        cSpan.className = 'amolee-product-info__compare-price';
        cSpan.textContent = formatDisplayMoney(effectiveCompare, currency);
        priceBlock.appendChild(cSpan);
      } else if (comparePriceElement) {
        comparePriceElement.textContent = formatDisplayMoney(effectiveCompare, currency);
      }

      var pct = Math.round(((effectiveCompare - productPriceWithAccent) * 100.0) / effectiveCompare);
      if (!discountBadge && priceBlock) {
        var bSpan = document.createElement('span');
        bSpan.className = 'amolee-product-info__discount-badge';
        bSpan.textContent = pct + '% OFF';
        priceBlock.appendChild(bSpan);
      } else if (discountBadge) {
        discountBadge.textContent = pct + '% OFF';
      }
    } else {
      if (comparePriceElement) comparePriceElement.remove();
      if (discountBadge) discountBadge.remove();
    }

    // Sticky/action area total reflects all selected add-ons
    var totalPriceEl = section.querySelector('#addon-total-price');
    if (totalPriceEl) totalPriceEl.textContent = formatDisplayMoney(total, currency);

    var mobileStickyPrice = section.querySelector('#amolee-sticky-addon-price');
    if (mobileStickyPrice) mobileStickyPrice.textContent = formatDisplayMoney(total, currency);

    var stickyOriginal = section.querySelector('.amolee-product-info__original-price');
    var priceAction = section.querySelector('.amolee-product-info__sticky-price');
    var mobileStickyCompare = section.querySelector('.amolee-sticky-add-to-bag__compare-price');
    var mobileStickyPricesContainer = section.querySelector('.amolee-sticky-add-to-bag__prices');

    if (effectiveCompare && effectiveCompare > productPriceWithAccent) {
      if (!stickyOriginal && priceAction) {
        var oSpan = document.createElement('span');
        oSpan.className = 'amolee-product-info__original-price';
        oSpan.textContent = formatDisplayMoney(effectiveCompare, currency);
        priceAction.appendChild(oSpan);
      } else if (stickyOriginal) {
        stickyOriginal.textContent = formatDisplayMoney(effectiveCompare, currency);
      }

      if (!mobileStickyCompare && mobileStickyPricesContainer) {
        var msSpan = document.createElement('span');
        msSpan.className = 'amolee-sticky-add-to-bag__compare-price';
        msSpan.textContent = formatDisplayMoney(effectiveCompare, currency);
        mobileStickyPricesContainer.appendChild(msSpan);
      } else if (mobileStickyCompare) {
        mobileStickyCompare.textContent = formatDisplayMoney(effectiveCompare, currency);
      }
    } else {
      if (stickyOriginal) stickyOriginal.remove();
      if (mobileStickyCompare) mobileStickyCompare.remove();
    }

    // Dynamic Additional Savings & Discounted Price (Offer's Info)
    updateOfferSavingsDisplay(productPriceWithAccent, currency);
  }

  /* ================================================================== */
  /*  WISHLIST TOGGLE                                                    */
  /* ================================================================== */
  // Managed by wishlist.js
  var wishlistBtn = section.querySelector('.amolee-product-info__wishlist');

  /* ================================================================== */
  /*  ACCORDION                                                          */
  /* ================================================================== */
  section.querySelectorAll('.amolee-accordion-header').forEach(function (header) {
    header.addEventListener('click', function () {
      var item = this.closest('.amolee-accordion-item');
      var open = item.classList.contains('is-open');
      item.classList.toggle('is-open', !open);
      this.setAttribute('aria-expanded', String(!open));

      // Toggle plus/minus icon
      var icon = header.querySelector('.amolee-accordion-icon');
      if (icon) {
        if (!open) {
          // Now expanded, show minus
          icon.innerHTML = '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 7H13" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';
        } else {
          // Now collapsed, show plus
          icon.innerHTML = '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7 1V13M1 7H13" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';
        }
      }
    });
  });

  /* ================================================================== */
  /*  FORM SUBMIT – certificate as separate cart item                    */
  /* ================================================================== */
  var productForm = section.querySelector('#amolee-product-form');
  var isAddingToCart = false;

  // Check if ALL engraving fields are required (product requires personalization before adding to cart)
  function engravingAllFieldsRequired() {
    if (!engravingInputs || !engravingInputs.length) return false;
    return Array.prototype.every.call(engravingInputs, function (input) {
      return String(input.dataset.required || 'true').toLowerCase() !== 'false';
    });
  }

  if (productForm) {
    productForm.addEventListener('submit', async function (e) {
      if (isAddingToCart) { e.preventDefault(); return; }

      // If engraving fields exist and all are required, force the user to fill them
      // even if the engraving checkbox is unchecked
      if (engravingInputs && engravingInputs.length && engravingAllFieldsRequired()) {
        if (!engravingCheckbox || !engravingCheckbox.checked) {
          // Force-check the checkbox and open the accordion
          e.preventDefault();
          if (engravingCheckbox) {
            engravingCheckbox.checked = true;
            engravingCheckbox.dispatchEvent(new Event('change', { bubbles: true }));
          }
          if (engravingWrapper) engravingWrapper.style.display = 'block';
          if (engravingSummary) engravingSummary.style.display = 'none';
          isEngravingExpanded = true;

          // Show error on each empty required field
          var errors = [];
          engravingInputs.forEach(function (input, index) {
            var label = getEngravingInputLabel(input, index);
            if (!String(input.value || '').trim()) {
              errors.push(label + ' is required.');
              input.classList.add('amolee-engraving-input--error');
            }
          });
          showEngravingErrors(errors.length ? errors : ['Please fill in the personalization fields.']);

          // Scroll the engraving section into view
          var engravingSection = section.querySelector('.amolee-addons__item');
          if (engravingSection) engravingSection.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return false;
        }

        // Checkbox is checked — validate the fields
        var engravingSaved = saveEngravingSelection(true);
        if (!engravingSaved) {
          e.preventDefault();
          return false;
        }
      } else if (engravingCheckbox && engravingCheckbox.checked) {
        var engravingSaved = saveEngravingSelection(true);
        if (!engravingSaved) {
          e.preventDefault();
          return false;
        }
      }

      var hasCertificate = selectedCertificateProductId && certificateCheckbox && certificateCheckbox.checked;
      var hasChain = selectedChainVariantId && chainCheckbox && chainCheckbox.checked;
      var hasPush = selectedPushVariantId && pushCheckbox && pushCheckbox.checked;

      if (!hasCertificate && !hasChain && !hasPush) {
        return true;
      }

      e.preventDefault();
      isAddingToCart = true;

      var addToCartBtn = section.querySelector('.amolee-product-info__add-to-cart');
      var stickyBtn = section.querySelector('#amolee-sticky-add-to-bag-btn');
      if (addToCartBtn) { addToCartBtn.disabled = true; addToCartBtn.textContent = 'ADDING...'; }
      if (stickyBtn) { stickyBtn.disabled = true; stickyBtn.textContent = 'ADDING...'; }

      var formData = new FormData(productForm);
      var productTitle = (section.querySelector('.amolee-product-info__title') || {}).textContent || '';
      productTitle = productTitle.trim();

      try {
        var getNumericId = function (id) {
          if (!id) return null;
          var s = String(id);
          if (s.includes('gid://')) { var parts = s.split('/'); return parts[parts.length - 1]; }
          return s;
        };

        var mainVarId = getNumericId(formData.get('id'));
        if (!mainVarId) throw new Error('Invalid variant ID');

        var mainItem = { id: mainVarId, quantity: parseInt(formData.get('quantity') || 1, 10) };

        formData.forEach(function (fieldValue, fieldName) {
          if (!fieldName || !/^properties\[.+\]$/.test(String(fieldName))) return;
          if (fieldValue === null || fieldValue === undefined) return;

          var normalizedValue = String(fieldValue).trim();
          if (!normalizedValue) return;

          var propertyKey = String(fieldName).replace(/^properties\[/, '').replace(/\]$/, '');
          if (!propertyKey) return;

          if (!mainItem.properties) mainItem.properties = {};
          mainItem.properties[propertyKey] = normalizedValue;
        });

        var items = [mainItem];

        // Add certificate as separate cart item
        if (hasCertificate) {
          var certVarId = getNumericId(selectedCertificateProductId);
          if (certVarId) {
            items.unshift({ id: certVarId, quantity: 1, properties: { 'For Product': productTitle } });
          }
        }

        // Add chain as separate cart item
        if (hasChain) {
          var chainVarId = getNumericId(selectedChainVariantId);
          if (chainVarId) {
            items.unshift({ id: chainVarId, quantity: 1, properties: { 'For Product': productTitle } });
          }
        }

        // Add push as separate cart item
        if (hasPush) {
          var pushVarId = getNumericId(selectedPushVariantId);
          if (pushVarId) {
            items.unshift({ id: pushVarId, quantity: 1, properties: { 'For Product': productTitle } });
          }
        }

        var getMarketPrefix = function () {
          var match = window.location.pathname.match(/^(\/[a-z]{2}(?:-[a-z]{2})?)(?:\/|$)/i);
          return match ? match[1] : '';
        };

        var marketPrefix = getMarketPrefix();
        var defaultRoot = marketPrefix ? (marketPrefix + '/') : '/';
        var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || defaultRoot;
        if (!rootUrl.endsWith('/')) rootUrl += '/';

        var cartAddUrl = (cfg && cfg.cartAddUrl)
          || (window.Theme && window.Theme.routes && window.Theme.routes.cart_add_url)
          || (rootUrl + 'cart/add.js');

        var cartUrl = (cfg && cfg.cartUrl)
          || (window.Theme && window.Theme.routes && window.Theme.routes.cart_url)
          || (rootUrl + 'cart');

        var response = await fetch(cartAddUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ items: items })
        });

        if (!response.ok) throw new Error('Failed to add items to cart');
        await response.json();
        window.location.href = cartUrl;
      } catch (error) {
        console.error('Error adding to cart:', error);
        alert('Failed to add items to cart. Please try again.');
        if (addToCartBtn) { addToCartBtn.disabled = false; addToCartBtn.textContent = 'ADD TO BAG'; }
        var stickyBtn = section.querySelector('#amolee-sticky-add-to-bag-btn');
        if (stickyBtn) { stickyBtn.disabled = false; stickyBtn.textContent = 'ADD TO BAG'; }
        isAddingToCart = false;
      }
    });
  }

  /* ------------------------------------------------------------------ */
  /*  Initialise title & description from the first rendered variant     */
  /* ------------------------------------------------------------------ */
  var initialVariant = getCurrentVariant();
  if (initialVariant) {
    syncOptionSelectorsToVariant(initialVariant);
  }
  updateVariantMeta(initialVariant);

  /* ------------------------------------------------------------------ */
  /*  AMOLIH CUSTOM PRICE DISPLAY START                                  */
  /*  Localize the server-rendered (native INR) price on first paint so  */
  /*  US/GB visitors immediately see their regional price + correct      */
  /*  compare-at handling. updatePriceWithAddons() also localizes the     */
  /*  main price and sticky total (incl. any default add-ons).           */
  /* ------------------------------------------------------------------ */
  refreshPriceDisplay(initialVariant);
  updatePriceWithAddons();
  syncWishlistButton(initialVariant);
  filterThumbnails();
  initStickyAddToBag();

  // Localize certificate card prices to current region
  certRadios.forEach(function (radio) {
    var card = radio.closest('.addon-card');
    if (card) {
      var priceSpan = card.querySelector('.addon-card__price');
      if (priceSpan) {
        var nativeMinor = radio.dataset && radio.dataset.price ? parseFloat(radio.dataset.price) * 100 : 0;
        var disp = getAddonRegionDisplay(radio, nativeMinor);
        priceSpan.textContent = '+' + formatDisplayMoney(disp.minor, disp.currency);
      }
    }
  });

  // Localize initial chain and push price labels to current region
  if (chainCfg) {
    var initialChainMatch = findChainVariant() || (chainCfg.variants ? chainCfg.variants.find(function (v) { return v.id === chainCfg.defaultVariantId; }) : null);
    if (initialChainMatch) {
      var chainDisp = getAddonRegionDisplay(initialChainMatch, initialChainMatch.price);
      var chainPriceLabel = section.querySelector('#chain-addon-price-label');
      if (chainPriceLabel) chainPriceLabel.textContent = '+\u00A0' + formatDisplayMoney(chainDisp.minor, chainDisp.currency);
    }
  }
  if (pushCfg) {
    var initialPushMatch = findPushVariant() || (pushCfg.variants ? pushCfg.variants.find(function (v) { return v.id === pushCfg.defaultVariantId; }) : null);
    if (initialPushMatch) {
      var pushDisp = getAddonRegionDisplay(initialPushMatch, initialPushMatch.price);
      var pushPriceLabel = section.querySelector('#push-addon-price-label');
      if (pushPriceLabel) pushPriceLabel.textContent = '+' + formatDisplayMoney(pushDisp.minor, pushDisp.currency);
    }
  }
  /*  AMOLIH CUSTOM PRICE DISPLAY END                                    */

  /* ================================================================== */
  /*  ESTIMATED DELIVERY NOTICE (Clean minimal single line)             */
  /* ================================================================== */
  var deliveryCfg = cfg.deliverySettings || {};
  var isDeliveryEnabled = deliveryCfg.enabled !== false;
  var simpleDeliveryTarget = section.querySelector('#amolee-delivery-target-date');
  var isProductPersonalized = Boolean(cfg.isPersonalized);
  var personalizedDays = parseInt(deliveryCfg.personalizedDays, 10) || 14;
  var standardDays = parseInt(deliveryCfg.standardDays, 10) || 10;
  var cutoffHour = typeof deliveryCfg.cutoffHour !== 'undefined' ? parseInt(deliveryCfg.cutoffHour, 10) : 14;
  if (isNaN(cutoffHour)) cutoffHour = 14;

  var MONTH_NAMES = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var DAY_NAMES = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

  function getOrdinalSuffix(day) {
    if (day >= 11 && day <= 13) return 'th';
    switch (day % 10) {
      case 1: return 'st';
      case 2: return 'nd';
      case 3: return 'rd';
      default: return 'th';
    }
  }

  function formatOrdinalDate(date) {
    if (!date) return '';
    var d = new Date(date);
    var dayName = DAY_NAMES[d.getDay()];
    var dayNum = d.getDate();
    var ord = getOrdinalSuffix(dayNum);
    var mon = MONTH_NAMES[d.getMonth()];
    return dayName + ', ' + dayNum + ord + ' ' + mon;
  }

  function isCurrentlyPersonalized() {
    if (isProductPersonalized) return true;
    if (typeof engravingCheckbox !== 'undefined' && engravingCheckbox && engravingCheckbox.checked) {
      return true;
    }
    return false;
  }

  function calculateEstimatedDeliveryDate() {
    var now = new Date();
    var days = isCurrentlyPersonalized() ? personalizedDays : standardDays;
    if (now.getHours() >= cutoffHour) {
      days += 1;
    }
    var deliveryDate = new Date(now.getFullYear(), now.getMonth(), now.getDate() + days);
    return deliveryDate;
  }

  function updateDeliveryTimeline(variant) {
    if (!isDeliveryEnabled || !simpleDeliveryTarget) return;
    var targetDate = calculateEstimatedDeliveryDate();
    simpleDeliveryTarget.textContent = formatOrdinalDate(targetDate);
  }

  updateDeliveryTimeline(initialVariant);

  /* ================================================================== */
  /*  CONFIDENCE BADGE: NON-RETURNABLE VS FREE 15-DAY RETURNS           */
  /* ================================================================== */
  var returnConfidenceItems = section.querySelectorAll('[data-confidence-returns]');

  function updateConfidenceReturnBadge() {
    if (!returnConfidenceItems.length) return;
    var isPersonalizedNow = isCurrentlyPersonalized();
    returnConfidenceItems.forEach(function (item) {
      var circle = item.querySelector('.amolee-confidence-circle');
      var label = item.querySelector('.amolee-confidence-label');
      if (isPersonalizedNow) {
        if (circle) {
          circle.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round">' +
            '<path d="M1 4v6h6"/>' +
            '<path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10"/>' +
            '<line x1="20" y1="4" x2="4" y2="20"/>' +
            '</svg>';
        }
        if (label) {
          label.textContent = 'Non-Returnable';
        }
      } else {
        if (circle) {
          circle.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round">' +
            '<path d="M1 4v6h6"/>' +
            '<path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10"/>' +
            '</svg>';
        }
        if (label) {
          label.textContent = 'Free 15-Day Returns';
        }
      }
    });
  }

  updateConfidenceReturnBadge();

  // Setup text rotation for offers strip (alternates between Save Additional and Get it for)
  function initOffersTextRotation() {
    var container = document.querySelector('.amolee-save-amount-info');
    if (!container) return;

    if (window.amoleeOffersRotationInterval) {
      clearInterval(window.amoleeOffersRotationInterval);
    }

    window.amoleeOffersRotationInterval = setInterval(function () {
      var active = container.querySelector('.amolee-toggle-msg.is-active');
      var msgs = container.querySelectorAll('.amolee-toggle-msg');
      if (msgs.length < 2) return;

      // Clear outgoing classes from previous runs
      msgs.forEach(function (msg) {
        msg.classList.remove('is-outgoing');
      });

      var next;
      if (active) {
        active.classList.remove('is-active');
        active.classList.add('is-outgoing'); // Animate out towards the top
        next = active.nextElementSibling;
      }
      if (!next || !next.classList.contains('amolee-toggle-msg')) {
        next = msgs[0];
      }
      next.classList.add('is-active'); // Animate in from the bottom
    }, 3000); // cycle every 3 seconds
  }

  initOffersTextRotation();

  function matchKeyword(altText, keyword) {
    var words = altText.toLowerCase().split(/[\s_\-\/]+/);
    return words.some(function (word) {
      return word === keyword || word.endsWith(keyword);
    });
  }

  function getMetalKeywords(selectedMetalDown) {
    if (!selectedMetalDown) return [];
    if (selectedMetalDown.indexOf('rose') > -1 || selectedMetalDown.indexOf('rg') > -1) {
      return ['rose', 'rg'];
    } else if (selectedMetalDown.indexOf('yellow') > -1 || selectedMetalDown.indexOf('yg') > -1) {
      return ['yellow', 'yg'];
    } else if (selectedMetalDown.indexOf('white') > -1 || selectedMetalDown.indexOf('wg') > -1 || selectedMetalDown.indexOf('silver') > -1 || selectedMetalDown.indexOf('ss') > -1 || selectedMetalDown.indexOf('rhodium') > -1) {
      return ['white', 'wg'];
    }
    return [];
  }

  function getGemstoneKeywords(selectedGemstoneDown) {
    if (!selectedGemstoneDown) return [];
    if (selectedGemstoneDown.indexOf('emerald') > -1) {
      return ['emerald', 'em', 'lge'];
    } else if (selectedGemstoneDown.indexOf('ruby') > -1) {
      return ['ruby', 'ru', 'lgr'];
    } else if (selectedGemstoneDown.indexOf('pink') > -1) {
      return ['pink', 'sap', 'ps', 'lgp', 'lgps'];
    } else if (selectedGemstoneDown.indexOf('blue') > -1) {
      return ['blue', 'sap', 'bs', 'lgb', 'lgbs'];
    } else if (selectedGemstoneDown.indexOf('diamond') > -1) {
      return ['diamond', 'dia', 'lgd'];
    }
    return [];
  }

  function filterThumbnails() {
    var metalInput = form ? form.querySelector('.amolee-metal-selector input[type="radio"]:checked') : null;
    var selectedMetal = metalInput ? metalInput.value : '';

    var gemstoneInput = form ? form.querySelector('.amolee-gemstone-selector input[type="radio"]:checked') : null;
    var selectedGemstone = gemstoneInput ? gemstoneInput.value : '';

    if (!selectedMetal && !selectedGemstone) return;

    var selectedMetalDown = selectedMetal.toLowerCase();
    var selectedGemstoneDown = selectedGemstone.toLowerCase();

    var metalKeywords = getMetalKeywords(selectedMetalDown);
    var gemstoneKeywords = getGemstoneKeywords(selectedGemstoneDown);

    var thumbs = document.querySelectorAll('.mobile-thumb-item');
    var visibleThumbs = [];

    thumbs.forEach(function (thumb) {
      if (thumb.classList.contains('side-view-thumb') || thumb.classList.contains('top-view-thumb') || thumb.classList.contains('model-thumb') || thumb.classList.contains('dimension-thumb') || thumb.classList.contains('packaging-thumb') || thumb.classList.contains('certificate-thumb')) {
        return;
      }

      var img = thumb.querySelector('img');
      var alt = img ? (img.getAttribute('alt') || '') : '';

      // Check if it belongs to ANOTHER metal explicitly
      var isOtherMetal = false;
      var allOtherMetals = [];
      if (selectedMetalDown.indexOf('rose') > -1 || selectedMetalDown.indexOf('rg') > -1) {
        allOtherMetals = ['yellow', 'yg', 'white', 'wg', 'silver', 'ss'];
      } else if (selectedMetalDown.indexOf('yellow') > -1 || selectedMetalDown.indexOf('yg') > -1) {
        allOtherMetals = ['white', 'wg', 'rose', 'rg', 'silver', 'ss'];
      } else if (selectedMetalDown.indexOf('white') > -1 || selectedMetalDown.indexOf('wg') > -1 || selectedMetalDown.indexOf('silver') > -1 || selectedMetalDown.indexOf('ss') > -1 || selectedMetalDown.indexOf('rhodium') > -1) {
        allOtherMetals = ['yellow', 'yg', 'rose', 'rg'];
      }

      allOtherMetals.forEach(function (m) {
        if (matchKeyword(alt, m)) {
          isOtherMetal = true;
        }
      });

      // Check if it belongs to ANOTHER gemstone explicitly
      var isOtherGemstone = false;
      var allOtherGemstones = [];
      if (selectedGemstoneDown.indexOf('emerald') > -1) {
        allOtherGemstones = ['ruby', 'ru', 'lgr', 'pink', 'blue', 'sap', 'ps', 'bs', 'lgp', 'lgb', 'lgps', 'lgbs', 'diamond', 'dia', 'lgd'];
      } else if (selectedGemstoneDown.indexOf('ruby') > -1) {
        allOtherGemstones = ['emerald', 'em', 'lge', 'pink', 'blue', 'sap', 'ps', 'bs', 'lgp', 'lgb', 'lgps', 'lgbs', 'diamond', 'dia', 'lgd'];
      } else if (selectedGemstoneDown.indexOf('pink') > -1) {
        allOtherGemstones = ['emerald', 'em', 'lge', 'ruby', 'ru', 'lgr', 'blue', 'bs', 'lgb', 'lgbs', 'diamond', 'dia', 'lgd'];
      } else if (selectedGemstoneDown.indexOf('blue') > -1) {
        allOtherGemstones = ['emerald', 'em', 'lge', 'ruby', 'ru', 'lgr', 'pink', 'ps', 'lgp', 'lgps', 'diamond', 'dia', 'lgd'];
      } else if (selectedGemstoneDown.indexOf('diamond') > -1) {
        allOtherGemstones = ['emerald', 'em', 'lge', 'ruby', 'ru', 'lgr', 'pink', 'blue', 'sap', 'ps', 'bs', 'lgp', 'lgb', 'lgps', 'lgbs'];
      }

      allOtherGemstones.forEach(function (g) {
        if (matchKeyword(alt, g)) {
          isOtherGemstone = true;
        }
      });

      if (thumb.dataset.mediaType === 'video') {
        var currentVariant = getCurrentVariant();
        var meta = (currentVariant && variantMeta[currentVariant.id]) || {};
        var metaVideoSrc = meta.video_media || '';

        var hasVideo = !!metaVideoSrc;
        var resolvedVideoSrc = metaVideoSrc;

        if (!hasVideo && productMedia) {
          productMedia.forEach(function (mediaItem) {
            if (mediaItem.media_type === 'video') {
              var altLower = mediaItem.alt ? mediaItem.alt.toLowerCase() : '';

              var isOtherM = false;
              var allOtherM = [];
              if (selectedMetalDown.indexOf('rose') > -1 || selectedMetalDown.indexOf('rg') > -1) {
                allOtherM = ['yellow', 'yg', 'white', 'wg', 'silver', 'ss'];
              } else if (selectedMetalDown.indexOf('yellow') > -1 || selectedMetalDown.indexOf('yg') > -1) {
                allOtherM = ['white', 'wg', 'rose', 'rg', 'silver', 'ss'];
              } else if (selectedMetalDown.indexOf('white') > -1 || selectedMetalDown.indexOf('wg') > -1 || selectedMetalDown.indexOf('silver') > -1 || selectedMetalDown.indexOf('ss') > -1 || selectedMetalDown.indexOf('rhodium') > -1) {
                allOtherM = ['yellow', 'yg', 'rose', 'rg'];
              }
              allOtherM.forEach(function (m) {
                if (altLower.indexOf(m) > -1) isOtherM = true;
              });

              var isOtherG = false;
              var allOtherG = [];
              if (selectedGemstoneDown.indexOf('emerald') > -1) {
                allOtherG = ['ruby', 'ru', 'lgr', 'pink', 'blue', 'sap', 'ps', 'bs', 'lgp', 'lgb', 'lgps', 'lgbs', 'diamond', 'dia', 'lgd'];
              } else if (selectedGemstoneDown.indexOf('ruby') > -1) {
                allOtherG = ['emerald', 'em', 'lge', 'pink', 'blue', 'sap', 'ps', 'bs', 'lgp', 'lgb', 'lgps', 'lgbs', 'diamond', 'dia', 'lgd'];
              } else if (selectedGemstoneDown.indexOf('pink') > -1) {
                allOtherG = ['emerald', 'em', 'lge', 'ruby', 'ru', 'lgr', 'blue', 'bs', 'lgb', 'lgbs', 'diamond', 'dia', 'lgd'];
              } else if (selectedGemstoneDown.indexOf('blue') > -1) {
                allOtherG = ['emerald', 'em', 'lge', 'ruby', 'ru', 'lgr', 'pink', 'ps', 'lgp', 'lgps', 'diamond', 'dia', 'lgd'];
              } else if (selectedGemstoneDown.indexOf('diamond') > -1) {
                allOtherG = ['emerald', 'em', 'lge', 'ruby', 'ru', 'lgr', 'pink', 'blue', 'sap', 'ps', 'bs', 'lgp', 'lgb', 'lgps', 'lgbs'];
              }
              allOtherG.forEach(function (g) {
                if (altLower.indexOf(g) > -1) isOtherG = true;
              });

              if (!isOtherM && !isOtherG) {
                var matchesG = gemstoneKeywords.length === 0;
                gemstoneKeywords.forEach(function (kw) {
                  if (altLower.indexOf(kw) > -1) matchesG = true;
                });
                var matchesM = metalKeywords.length === 0;
                metalKeywords.forEach(function (kw) {
                  if (altLower.indexOf(kw) > -1) matchesM = true;
                });
                if (matchesG && matchesM) {
                  var source = mediaItem.sources ? mediaItem.sources.find(function (s) { return s.format === 'mp4'; }) : null;
                  resolvedVideoSrc = source ? source.url : (mediaItem.sources && mediaItem.sources[0] ? mediaItem.sources[0].url : '');
                  hasVideo = true;
                }
              }
            }
          });
        }

        if (hasVideo) {
          thumb.style.display = 'block';
          thumb.dataset.videoSrc = resolvedVideoSrc;
          thumb.classList.remove('is-hidden');
          visibleThumbs.push(thumb);
        } else {
          thumb.style.display = 'none';
          thumb.classList.add('is-hidden');
          thumb.classList.remove('is-active');
        }
        return;
      }

      // If it belongs to another metal or gemstone, hide it
      var show = true;
      if (isOtherMetal || isOtherGemstone) {
        show = false;
      }

      // If it explicitly contains the current metal keyword AND current gemstone keyword, always show it
      var hasCurrentMetal = false;
      metalKeywords.forEach(function (kw) {
        if (matchKeyword(alt, kw)) hasCurrentMetal = true;
      });

      var hasCurrentGemstone = false;
      gemstoneKeywords.forEach(function (kw) {
        if (matchKeyword(alt, kw)) hasCurrentGemstone = true;
      });

      if (hasCurrentMetal && (gemstoneKeywords.length === 0 || hasCurrentGemstone)) {
        show = true;
      }

      if (show) {
        thumb.style.display = 'block';
        visibleThumbs.push(thumb);
      } else {
        thumb.style.display = 'none';
        thumb.classList.remove('is-active');
      }
    });

    // Populate and update the 2x1 grid on the main stage
    updateGridMedia();
  }

  function updateGridMedia(forcedImgUrl) {
    var thumbs = document.querySelectorAll('.mobile-thumb-item');

    var videoThumb = document.querySelector('.mobile-thumb-item.video-thumb');
    var videoSrc = (videoThumb && videoThumb.style.display !== 'none' && !videoThumb.classList.contains('is-hidden')) ? videoThumb.dataset.videoSrc : '';

    var imgUrl = forcedImgUrl || originalSrc;
    if (!imgUrl) {
      var visibleThumbs = Array.from(thumbs).filter(function (t) { return t.style.display !== 'none' && !t.classList.contains('is-hidden'); });
      var activeThumb = document.querySelector('.mobile-thumb-item.is-active');
      if (!activeThumb || activeThumb.style.display === 'none' || activeThumb.classList.contains('is-hidden')) {
        activeThumb = visibleThumbs.find(function (t) { return t.dataset.mediaType !== 'video'; }) || visibleThumbs[0];
      }
      imgUrl = activeThumb ? activeThumb.dataset.imageSrc : '';
    }

    var img = document.getElementById('MainProductImage');
    if (img && imgUrl) {
      img.src = imgUrl;
    }

    // Current variant side view and top view images
    var currentVariant = getCurrentVariant();
    var meta = (currentVariant && variantMeta[currentVariant.id]) || {};
    var sideViewSrc = (meta && typeof meta.side_view_image !== 'undefined') ? meta.side_view_image : currentSideViewSrc;
    var topViewSrc = (meta && typeof meta.top_view_image !== 'undefined') ? meta.top_view_image : currentTopViewSrc;

    // Update Side View Card
    var sideViewCard = document.querySelector('.side-view-card');
    var gallerySideViewImage = document.getElementById('GallerySideViewImage');
    if (sideViewCard && gallerySideViewImage) {
      if (sideViewSrc) {
        gallerySideViewImage.src = sideViewSrc;
        gallerySideViewImage.style.display = 'block';
        sideViewCard.classList.remove('is-hidden');
        specialViewMap.side_view.src = sideViewSrc;
      } else {
        sideViewCard.classList.add('is-hidden');
        specialViewMap.side_view.src = '';
      }
    }

    // Update Side View Mobile Thumb
    var sideViewThumb = document.querySelector('.mobile-thumb-item.side-view-thumb');
    var mobileThumbSideViewImage = document.getElementById('MobileThumbSideViewImage');
    if (sideViewThumb) {
      if (sideViewSrc) {
        sideViewThumb.dataset.imageSrc = sideViewSrc;
        if (mobileThumbSideViewImage) {
          mobileThumbSideViewImage.src = sideViewSrc;
          mobileThumbSideViewImage.style.display = 'block';
        }
        sideViewThumb.style.display = 'block';
        sideViewThumb.classList.remove('is-hidden');
      } else {
        sideViewThumb.dataset.imageSrc = '';
        if (mobileThumbSideViewImage) {
          mobileThumbSideViewImage.style.display = 'none';
        }
        sideViewThumb.style.display = 'none';
        sideViewThumb.classList.add('is-hidden');
        sideViewThumb.classList.remove('is-active');
      }
    }

    // Update Top View Card
    var topViewCard = document.querySelector('.top-view-card');
    var galleryTopViewImage = document.getElementById('GalleryTopViewImage');
    if (topViewCard && galleryTopViewImage) {
      if (topViewSrc) {
        galleryTopViewImage.src = topViewSrc;
        galleryTopViewImage.style.display = 'block';
        topViewCard.classList.remove('is-hidden');
        specialViewMap.top_view.src = topViewSrc;
      } else {
        topViewCard.classList.add('is-hidden');
        specialViewMap.top_view.src = '';
      }
    }

    // Update Top View Mobile Thumb
    var topViewThumb = document.querySelector('.mobile-thumb-item.top-view-thumb');
    var mobileThumbTopViewImage = document.getElementById('MobileThumbTopViewImage');
    if (topViewThumb) {
      if (topViewSrc) {
        topViewThumb.dataset.imageSrc = topViewSrc;
        if (mobileThumbTopViewImage) {
          mobileThumbTopViewImage.src = topViewSrc;
          mobileThumbTopViewImage.style.display = 'block';
        }
        topViewThumb.style.display = 'block';
        topViewThumb.classList.remove('is-hidden');
      } else {
        topViewThumb.dataset.imageSrc = '';
        if (mobileThumbTopViewImage) {
          mobileThumbTopViewImage.style.display = 'none';
        }
        topViewThumb.style.display = 'none';
        topViewThumb.classList.add('is-hidden');
        topViewThumb.classList.remove('is-active');
      }
    }

    // If currently active special view is side_view or top_view, update or exit
    if (activeSpecialView === 'side_view') {
      if (sideViewSrc) {
        swapMainImage(sideViewSrc);
      } else {
        exitSpecialView();
      }
    } else if (activeSpecialView === 'top_view') {
      if (topViewSrc) {
        swapMainImage(topViewSrc);
      } else {
        exitSpecialView();
      }
    }

    // Model & Dimension images are always fixed to the product level
    var modelSrc = viewModelSrc;
    var dimensionSrc = viewDimensionSrc;

    // Update Model Card
    var modelCard = document.querySelector('.model-card');
    var galleryModelImage = document.getElementById('GalleryModelImage');
    if (modelCard && galleryModelImage) {
      if (modelSrc) {
        galleryModelImage.src = modelSrc;
        galleryModelImage.style.display = 'block';
        modelCard.classList.remove('is-hidden');
        specialViewMap.model.src = modelSrc;
      } else {
        modelCard.classList.add('is-hidden');
        specialViewMap.model.src = '';
      }
    }

    // Update Dimension Card
    var dimensionCard = document.querySelector('.dimension-card');
    var galleryDimensionImage = document.getElementById('GalleryDimensionImage');
    if (dimensionCard && galleryDimensionImage) {
      if (dimensionSrc) {
        galleryDimensionImage.src = dimensionSrc;
        galleryDimensionImage.style.display = 'block';
        dimensionCard.classList.remove('is-hidden');
        specialViewMap.dimension.src = dimensionSrc;
      } else {
        dimensionCard.classList.add('is-hidden');
        specialViewMap.dimension.src = '';
      }
    }

    // Update Packaging Card
    var packagingCard = document.querySelector('.packaging-card');
    var galleryPackagingImage = document.getElementById('GalleryPackagingImage');
    if (packagingCard && galleryPackagingImage) {
      if (viewPackagingSrc) {
        galleryPackagingImage.src = viewPackagingSrc;
        galleryPackagingImage.style.display = 'block';
        packagingCard.classList.remove('is-hidden');
        specialViewMap.packaging.src = viewPackagingSrc;
      } else {
        packagingCard.classList.add('is-hidden');
        specialViewMap.packaging.src = '';
      }
    }

    // Update Certificate Card
    var certificateCard = document.querySelector('.certificate-card');
    var galleryCertificateImage = document.getElementById('GalleryCertificateImage');
    if (certificateCard && galleryCertificateImage) {
      if (viewCertificateSrc) {
        galleryCertificateImage.src = viewCertificateSrc;
        galleryCertificateImage.style.display = 'block';
        certificateCard.classList.remove('is-hidden');
        specialViewMap.certificate.src = viewCertificateSrc;
      } else {
        certificateCard.classList.add('is-hidden');
        specialViewMap.certificate.src = '';
      }
    }

    // Update Video Card
    var videoCard = document.querySelector('.video-card');
    var galleryVideo = document.getElementById('GalleryProductVideo');

    if (videoCard && galleryVideo) {
      if (videoSrc) {
        var normalizeVideoSrc = videoSrc.startsWith('//') ? window.location.protocol + videoSrc : videoSrc;
        if (galleryVideo.src !== normalizeVideoSrc) {
          galleryVideo.src = normalizeVideoSrc;
          galleryVideo.load();
        }
        // Autoplay the video (muted is already set in the video tag)
        galleryVideo.play().catch(function (e) {
          console.log("Autoplay blocked/failed:", e);
        });
        videoCard.classList.remove('is-hidden');
      } else {
        galleryVideo.pause();
        videoCard.classList.add('is-hidden');
      }
    }

    // Sync Single vs Grid layout
    var grid = document.querySelector('.amolee-media-grid');
    var layout = document.querySelector('.amolee-product-layout');
    var mobileThumbsRow = document.querySelector('.mobile-thumbs-row');
    var hasSecondary = !!videoSrc || !!modelSrc || !!dimensionSrc || !!viewPackagingSrc || !!viewCertificateSrc || !!sideViewSrc || !!topViewSrc;
    if (grid) {
      if (hasSecondary) {
        grid.classList.remove('amolee-media-grid--single');
        if (layout) layout.classList.remove('amolee-product-layout--single-media');
        if (mobileThumbsRow) mobileThumbsRow.classList.remove('mobile-thumbs-row--hidden');
      } else {
        grid.classList.add('amolee-media-grid--single');
        if (layout) layout.classList.add('amolee-product-layout--single-media');
        if (mobileThumbsRow) mobileThumbsRow.classList.add('mobile-thumbs-row--hidden');
      }

      var visibleCount = 1;
      if (sideViewSrc) visibleCount++;
      if (topViewSrc) visibleCount++;
      if (modelSrc) visibleCount++;
      if (videoSrc) visibleCount++;
      if (dimensionSrc) visibleCount++;
      if (viewPackagingSrc) visibleCount++;
      if (viewCertificateSrc) visibleCount++;

      grid.classList.toggle('amolee-media-grid--has-3', visibleCount === 3);
      grid.classList.toggle('amolee-media-grid--has-5', visibleCount === 5);
      grid.classList.toggle('amolee-media-grid--has-7', visibleCount === 7);

      var emptyCard = grid.querySelector('.empty-card');
      if (emptyCard) {
        emptyCard.classList.add('is-hidden');
        emptyCard.style.display = 'none';
      }
    }
  }

  /* ================================================================== */
  /*  CUSTOM PRODUCT MEDIA MODAL WINDOW (DESKTOP ONLY)                  */
  /* ================================================================== */
  var mediaModal = document.getElementById('amolee-media-modal');
  var modalMedias = [];
  var modalIndex = 0;

  function getGridMedias() {
    var list = [];

    // 1. Main image wrapper active media
    var specialImg = document.getElementById('SpecialProductImage');
    var mainVideo = document.getElementById('MainProductVideo');
    var mainImg = document.getElementById('MainProductImage');

    if (specialImg && specialImg.style.display !== 'none' && specialImg.src) {
      list.push({ type: 'image', src: specialImg.src });
    } else if (mainVideo && mainVideo.style.display !== 'none' && mainVideo.src) {
      list.push({ type: 'video', src: mainVideo.src });
    } else if (mainImg && mainImg.src) {
      list.push({ type: 'image', src: mainImg.src });
    }

    // 2. Side view card
    var sideViewCard = document.querySelector('.amolee-media-grid .media-gallery-card.side-view-card');
    if (sideViewCard && !sideViewCard.classList.contains('is-hidden') && sideViewCard.style.display !== 'none') {
      var sideImg = document.getElementById('GallerySideViewImage');
      if (sideImg && sideImg.src && sideImg.style.display !== 'none') {
        list.push({ type: 'image', src: sideImg.src });
      }
    }

    // 3. Top view card
    var topViewCard = document.querySelector('.amolee-media-grid .media-gallery-card.top-view-card');
    if (topViewCard && !topViewCard.classList.contains('is-hidden') && topViewCard.style.display !== 'none') {
      var topImg = document.getElementById('GalleryTopViewImage');
      if (topImg && topImg.src && topImg.style.display !== 'none') {
        list.push({ type: 'image', src: topImg.src });
      }
    }

    // 4. Model card
    var modelCard = document.querySelector('.amolee-media-grid .media-gallery-card.model-card');
    if (modelCard && !modelCard.classList.contains('is-hidden') && modelCard.style.display !== 'none') {
      var modelImg = document.getElementById('GalleryModelImage');
      if (modelImg && modelImg.src) {
        list.push({ type: 'image', src: modelImg.src });
      }
    }

    // 3. Video card
    var videoCard = document.querySelector('.amolee-media-grid .media-gallery-card.video-card');
    if (videoCard && !videoCard.classList.contains('is-hidden') && videoCard.style.display !== 'none') {
      var galleryVideo = document.getElementById('GalleryProductVideo');
      if (galleryVideo) {
        var videoSrc = galleryVideo.src;
        if (!videoSrc) {
          var sourceTag = galleryVideo.querySelector('source');
          if (sourceTag) videoSrc = sourceTag.src;
        }
        if (videoSrc) {
          list.push({ type: 'video', src: videoSrc });
        }
      }
    }

    // 4. Dimension card
    var dimensionCard = document.querySelector('.amolee-media-grid .media-gallery-card.dimension-card');
    if (dimensionCard && !dimensionCard.classList.contains('is-hidden') && dimensionCard.style.display !== 'none') {
      var dimImg = document.getElementById('GalleryDimensionImage');
      if (dimImg && dimImg.src) {
        list.push({ type: 'image', src: dimImg.src });
      }
    }

    // 5. Packaging card
    var packagingCard = document.querySelector('.amolee-media-grid .media-gallery-card.packaging-card');
    if (packagingCard && !packagingCard.classList.contains('is-hidden') && packagingCard.style.display !== 'none') {
      var packImg = document.getElementById('GalleryPackagingImage');
      if (packImg && packImg.src) {
        list.push({ type: 'image', src: packImg.src });
      }
    }

    // 6. Certificate card
    var certificateCard = document.querySelector('.amolee-media-grid .media-gallery-card.certificate-card');
    if (certificateCard && !certificateCard.classList.contains('is-hidden') && certificateCard.style.display !== 'none') {
      var certImg = document.getElementById('GalleryCertificateImage');
      if (certImg && certImg.src) {
        list.push({ type: 'image', src: certImg.src });
      }
    }

    return list;
  }

  function updateModalMedia() {
    if (!mediaModal) return;
    var container = mediaModal.querySelector('.amolee-media-modal__media-container');
    if (!container) return;

    var media = modalMedias[modalIndex];
    if (!media) return;

    container.innerHTML = '';
    if (media.type === 'video') {
      var video = document.createElement('video');
      video.src = media.src;
      video.controls = true;
      video.autoplay = true;
      video.muted = true;
      video.loop = true;
      video.playsInline = true;
      container.appendChild(video);
    } else {
      var img = document.createElement('img');
      img.src = media.src;
      img.alt = 'Zoomed product media';
      container.appendChild(img);
    }

    // Hide arrows if only 1 media
    var leftArrow = mediaModal.querySelector('.amolee-media-modal__arrow--left');
    var rightArrow = mediaModal.querySelector('.amolee-media-modal__arrow--right');
    if (leftArrow && rightArrow) {
      if (modalMedias.length > 1) {
        leftArrow.style.display = 'flex';
        rightArrow.style.display = 'flex';
      } else {
        leftArrow.style.display = 'none';
        rightArrow.style.display = 'none';
      }
    }
  }

  function openMediaModal(medias, startIndex) {
    if (!mediaModal) return;
    modalMedias = medias;
    modalIndex = startIndex;
    updateModalMedia();
    mediaModal.showModal();
  }

  // Bind clicks inside the 2x2 grid
  var mediaGrid = document.querySelector('.amolee-media-grid');
  if (mediaGrid) {
    mediaGrid.addEventListener('click', function (e) {
      // Only execute if on desktop view (>768px screen width)
      if (window.innerWidth <= 768) return;

      var target = e.target.closest('.main-image-wrapper, .media-gallery-card:not(.empty-card)');
      if (!target) return;

      var clickedSrc = '';
      if (target.classList.contains('main-image-wrapper')) {
        var specialImg = document.getElementById('SpecialProductImage');
        var mainVideo = document.getElementById('MainProductVideo');
        var mainImg = document.getElementById('MainProductImage');
        if (specialImg && specialImg.style.display !== 'none') clickedSrc = specialImg.src;
        else if (mainVideo && mainVideo.style.display !== 'none') clickedSrc = mainVideo.src;
        else if (mainImg) clickedSrc = mainImg.src;
      } else if (target.classList.contains('side-view-card')) {
        var sideImg = document.getElementById('GallerySideViewImage');
        if (sideImg) clickedSrc = sideImg.src;
      } else if (target.classList.contains('top-view-card')) {
        var topImg = document.getElementById('GalleryTopViewImage');
        if (topImg) clickedSrc = topImg.src;
      } else if (target.classList.contains('video-card')) {
        var galleryVideo = document.getElementById('GalleryProductVideo');
        if (galleryVideo) clickedSrc = galleryVideo.src || (galleryVideo.querySelector('source') && galleryVideo.querySelector('source').src);
      } else if (target.classList.contains('model-card')) {
        var modelImg = document.getElementById('GalleryModelImage');
        if (modelImg) clickedSrc = modelImg.src;
      } else if (target.classList.contains('dimension-card')) {
        var dimImg = document.getElementById('GalleryDimensionImage');
        if (dimImg) clickedSrc = dimImg.src;
      } else if (target.classList.contains('packaging-card')) {
        var packImg = document.getElementById('GalleryPackagingImage');
        if (packImg) clickedSrc = packImg.src;
      } else if (target.classList.contains('certificate-card')) {
        var certImg = document.getElementById('GalleryCertificateImage');
        if (certImg) clickedSrc = certImg.src;
      }

      if (!clickedSrc) return;

      var gridMedias = getGridMedias();
      var startIndex = gridMedias.findIndex(function (m) {
        return m.src === clickedSrc;
      });
      if (startIndex === -1) startIndex = 0;

      openMediaModal(gridMedias, startIndex);
    });
  }

  if (mediaModal) {
    // Close button
    var closeBtn = mediaModal.querySelector('.amolee-media-modal__close');
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        mediaModal.close();
      });
    }

    // Backdrop click close
    mediaModal.addEventListener('click', function (e) {
      if (e.target === mediaModal) {
        mediaModal.close();
      }
    });

    // Arrow controls
    var leftArrow = mediaModal.querySelector('.amolee-media-modal__arrow--left');
    var rightArrow = mediaModal.querySelector('.amolee-media-modal__arrow--right');

    if (leftArrow) {
      leftArrow.addEventListener('click', function (e) {
        e.stopPropagation();
        if (modalMedias.length > 1) {
          modalIndex = (modalIndex - 1 + modalMedias.length) % modalMedias.length;
          updateModalMedia();
        }
      });
    }

    if (rightArrow) {
      rightArrow.addEventListener('click', function (e) {
        e.stopPropagation();
        if (modalMedias.length > 1) {
          modalIndex = (modalIndex + 1) % modalMedias.length;
          updateModalMedia();
        }
      });
    }

    // Keyboard controls
    mediaModal.addEventListener('keydown', function (e) {
      if (modalMedias.length <= 1) return;
      if (e.key === 'ArrowLeft') {
        modalIndex = (modalIndex - 1 + modalMedias.length) % modalMedias.length;
        updateModalMedia();
      } else if (e.key === 'ArrowRight') {
        modalIndex = (modalIndex + 1) % modalMedias.length;
        updateModalMedia();
      }
    });

    // Pause/clean up on close
    mediaModal.addEventListener('close', function () {
      var container = mediaModal.querySelector('.amolee-media-modal__media-container');
      if (container) container.innerHTML = '';
    });
  }

  /* ================================================================== */
  /*  MOBILE STICKY ADD TO BAG BUTTON (Amazon & Flipkart Behavior)       */
  /* ================================================================== */
  function initStickyAddToBag() {
    var originalBtn = document.getElementById('amolee-add-to-cart-button') || section.querySelector('.amolee-product-info__add-to-cart') || document.querySelector('.amolee-product-info__add-to-cart');
    var stickyBar = document.getElementById('amolee-sticky-add-to-bag') || (section && section.querySelector('.amolee-sticky-add-to-bag')) || document.querySelector('.amolee-sticky-add-to-bag');
    var stickyBtn = document.getElementById('amolee-sticky-add-to-bag-btn') || (section && section.querySelector('#amolee-sticky-add-to-bag-btn')) || document.querySelector('#amolee-sticky-add-to-bag-btn');
    var infoEl = (section && section.querySelector('.amolee-sticky-add-to-bag__info')) || document.querySelector('.amolee-sticky-add-to-bag__info');

    if (!originalBtn || !stickyBar || !stickyBtn) return;

    var isMobile = function () {
      return window.matchMedia('(max-width: 768px)').matches || window.innerWidth <= 768;
    };

    var adjustHelpButtonPosition = function (isStickyVisible) {
      var btn = document.querySelector('.helpdesk-channel-start-btn');
      var btnShow = document.querySelector('.helpdesk-channel-btn-show');
      var target = btn || btnShow;
      if (btn && btnShow && btn !== btnShow) {
        var btnPos = window.getComputedStyle(btn).position;
        var showPos = window.getComputedStyle(btnShow).position;
        if (btnPos === 'static' && (showPos === 'fixed' || showPos === 'absolute')) {
          target = btnShow;
        }
      }
      if (target) {
        var targetBottom = 'calc(6px + env(safe-area-inset-bottom, 0px) + 10px)';
        if (isStickyVisible && isMobile()) {
          if (target.style.getPropertyValue('bottom') !== targetBottom) {
            target.style.setProperty('bottom', targetBottom, 'important');
          }
        } else {
          if (target.style.getPropertyValue('bottom') === targetBottom) {
            target.style.removeProperty('bottom');
          }
        }
      }
    };

    if ('MutationObserver' in window && !window._helpBtnStickyObserver) {
      window._helpBtnStickyObserver = new MutationObserver(function () {
        if (isMobile() && document.body.classList.contains('has-sticky-add-to-bag')) {
          adjustHelpButtonPosition(true);
        }
      });
      window._helpBtnStickyObserver.observe(document.body, { childList: true, subtree: true });
    }

    var showSticky = function () {
      if (!isMobile()) return;
      stickyBar.classList.add('is-visible');
      stickyBar.setAttribute('aria-hidden', 'false');
      document.body.classList.add('has-sticky-add-to-bag');
      adjustHelpButtonPosition(true);
    };

    var hideSticky = function () {
      stickyBar.classList.remove('is-visible');
      stickyBar.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('has-sticky-add-to-bag');
      adjustHelpButtonPosition(false);
    };

    // Keep initial state synchronized
    stickyBtn.disabled = originalBtn.disabled;
    stickyBtn.textContent = originalBtn.textContent.trim();

    // Dual-layer state sync via MutationObserver on original button
    if ('MutationObserver' in window && !stickyBtn._hasSyncObserver) {
      stickyBtn._hasSyncObserver = true;
      var syncObserver = new MutationObserver(function () {
        if (stickyBtn.disabled !== originalBtn.disabled) {
          stickyBtn.disabled = originalBtn.disabled;
        }
        var origText = originalBtn.textContent.trim();
        if (stickyBtn.textContent.trim() !== origText) {
          stickyBtn.textContent = origText;
        }
      });
      syncObserver.observe(originalBtn, {
        attributes: true,
        attributeFilter: ['disabled', 'class'],
        childList: true,
        characterData: true,
        subtree: true
      });
    }

    // Delegate click to original button to trigger validations, add-ons & form submission
    if (!stickyBtn._hasClickHandler) {
      stickyBtn._hasClickHandler = true;
      stickyBtn.addEventListener('click', function (e) {
        e.preventDefault();
        if (originalBtn.disabled || isAddingToCart) return;
        originalBtn.click();
      });
    }

    // Clicking product snapshot info scrolls smoothly to product details / actions
    if (infoEl && !infoEl._hasClickHandler) {
      infoEl._hasClickHandler = true;
      infoEl.addEventListener('click', function () {
        var actionsBlock = originalBtn.closest('.amolee-product-info__actions') || originalBtn;
        actionsBlock.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }

    // Visibility evaluator: shows sticky button whenever original button is outside viewport
    var updateVisibility = function () {
      if (!isMobile()) {
        hideSticky();
        return;
      }
      var rect = originalBtn.getBoundingClientRect();
      var isInViewport = (
        rect.bottom > 0 &&
        rect.top < (window.innerHeight || document.documentElement.clientHeight)
      );

      if (isInViewport) {
        // Original button is visible in viewport -> hide sticky button
        hideSticky();
      } else {
        // Original button is outside visible viewport -> show sticky button!
        showSticky();
      }
    };

    // IntersectionObserver to observe visibility of original Add to Bag button
    if ('IntersectionObserver' in window) {
      if (window._stickyAddObserver) {
        window._stickyAddObserver.disconnect();
      }
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!isMobile()) {
            hideSticky();
            return;
          }

          if (entry.isIntersecting) {
            // Original button is visible in viewport -> automatically hide sticky button
            hideSticky();
          } else {
            // Original button is outside viewport -> show sticky button!
            showSticky();
          }
        });
      }, {
        root: null,
        threshold: 0,
        rootMargin: '0px'
      });

      observer.observe(originalBtn);
      window._stickyAddObserver = observer;
    }

    // Run immediate check so button displays right away on mobile view
    updateVisibility();

    // Scroll listener to ensure immediate response
    window.removeEventListener('scroll', updateVisibility);
    window.addEventListener('scroll', updateVisibility, { passive: true });

    // Responsive listener to ensure desktop layout remains untouched
    window.addEventListener('resize', function () {
      if (!isMobile()) {
        hideSticky();
      } else {
        updateVisibility();
      }
    }, { passive: true });
  }

  // Breakpoint listener for responsive switching between Desktop (>768px) and Mobile (<=768px)
  var desktopMediaQuery = window.matchMedia('(min-width: 769px)');
  function handleBreakpointChange(e) {
    if (e.matches) {
      // Switched to desktop (>768px):
      // Restore default 2x2 grid where slot 1 is the main product image (avoiding duplicate model/video cards)
      exitSpecialView();
      updateGridMedia();
      var stickyBar = document.getElementById('amolee-sticky-add-to-bag');
      if (stickyBar) {
        stickyBar.classList.remove('is-visible');
        stickyBar.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('has-sticky-add-to-bag');
      }
    } else {
      // Switched to mobile (<=768px):
      syncActiveThumbnail();
      initStickyAddToBag();
    }
  }

  if (desktopMediaQuery.addEventListener) {
    desktopMediaQuery.addEventListener('change', handleBreakpointChange);
  } else if (desktopMediaQuery.addListener) {
    desktopMediaQuery.addListener(handleBreakpointChange);
  }
});